import React, { useEffect, useRef, useState } from "react";
import {
  Container, Card, CardBody, Table, Spinner, Button,
  Badge, Modal, ModalBody, Row, Col, Form, FormGroup, Input, ModalHeader,
  InputGroup,
  InputGroupText,
  Label,
  CardHeader,
  ModalFooter,
  Progress
} from "reactstrap";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { toast } from "react-toastify";
import {
  getMyTasks, updateMyTask, updateMySubTask,
  OverallLogDTO,
  getTaskLogs,
  getSubTaskLogs,
  getUnreadCount,
  getComments,
  CreateTimeSheetDTO,
  updateTimeSheet,
  createTimeSheet,
  getProjectNames,
  ChildSubTaskViewDTO,
  addComment,
} from "../../Api/ApiUrlConst";
import { CheckCircleIcon, Clock, EditIcon, Rocket, Settings2Icon, SettingsIcon } from "lucide-react";
import { Save as SaveIcon, Cancel as CancelIcon, AddAlarm as AddAlarmIcon } from "@mui/icons-material";

import { useAuth } from "../../Context/AuthContext";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Comments from "../CommentComponent/Comments";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import ChatIcon from '@mui/icons-material/Chat';
import HttpsIcon from '@mui/icons-material/Https';
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getMyChildSubTasks,
  getMyChildSubTaskById,
  updateMyChildSubTask
} from "../../Api/ApiUrlConst";
import { ChildSubTaskUpdateTMDto } from "../../Api/ApiUrlConst";
import { Tooltip } from "@mui/material";



// Define an interface for the current user's data
interface CurrentUser {
  id: string;
  name: string;
}
export interface SubTaskList {
  id: number;
  title?: string;
  description: string;
  assignedToId?: string; // MODIFIED: Added for accurate permission checks
  assignedToName?: string;
  createdByName?: string;
  dueDate: string;
  isDueDateLocked?: boolean;
  status: string;
  workHours?: number;
  completionDate?: string;
  remarks?: string;
  issues?: string;
  percentCompleted?: number;
  priority?: string;
  spentHours?: number;
  maxHours?: number;
  childSubTasks?: ChildSubTask[];
}
export interface TaskList {
  id: number;
  projectName: string;
  description?: string;
  assignedToId?: string;
  dueDate: string;
  status: string;
  createdByName: string;
  assignedToName: string;
  percentCompleted?: number;
  isDueDateLocked?: boolean;
  completionDate?: string;
  remarks?: string;
  issues?: string;
  subTasks?: SubTaskList[];
  priority?: string;
  spentHours?: number;
  maxHours?: number;
}
interface TimeSheetRow {
  date?: string;
  projectName?: string;
  module?: string;
  product?: string;
  part?: string;
  hours?: number;
  assignedBy?: string;
  description?: string;

  draftingType?: string;
  quantity?: number;
  totPages?: number;
  subTask?: string;
  childSubTask?: string;
  taskId?: number;
  subTaskId?: number;
  taskDescription?: string;
  subTaskDescription?: string;
  childSubTaskDescription?: string;
  createdByName?: string;
}

export interface ChildSubTask {
  subTaskId?: number;
  id: number;
  title?: string;
  description: string;
  assignedToId?: string; // MODIFIED: Added for accurate permission checks
  dueDate: string;
  isDueDateLocked?: boolean;
  status: string;
  workHours?: number;
  completionDate?: string;
  remarks?: string;
  issues?: string;
  percentCompleted?: number;
  priority?: string;
  spentHours?: number;
  maxHours?: number;
  teamMemberNames?: string[];
  createdByName?: string;


}


const statusColorMap: Record<string, string> = {
  'Yet to Start': 'status-yet-to-start',
  YetToStart: 'status-yet-to-start',

  'On Hold': 'status-on-hold',
  OnHold: 'status-on-hold',

  'Waiting for Input': 'status-waiting-input',
  WaitingForInput: 'status-waiting-input',

  'Modelling in Progress': 'status-modelling-progress',
  ModellingInProgress: 'status-modelling-progress',

  'Modelling ToDo': 'status-modelling-Todo',
  ModellingTodo: 'status-modelling-Todo',

  'Modelling Completed': 'status-modelling-completed',
  ModellingCompleted: 'status-modelling-completed',

  'Drafting in Progress': 'status-drafting-progress',
  DraftingInProgress: 'status-drafting-progress',

  'Drafting ToDo': 'status-drafting-Todo',
  DraftingTodo: 'status-drafting-Todo',

  'Drafting Completed': 'status-drafting-completed',
  DraftingCompleted: 'status-drafting-completed',

  'QC ToDo': 'status-qc-Todo',
  QCTodo: 'status-qc-Todo',

  'QC in Progress': 'status-qc-progress',
  QCInProgress: 'status-qc-progress',

  'QC Completed': 'status-qc-completed',
  QCCompleted: 'status-qc-completed',

  'Client Review in Progress': 'status-client-review-progress',
  ClientReviewInProgress: 'status-client-review-progress',

  'Client Review ToDo': 'status-client-review-Todo',
  ClientReviewTodo: 'status-client-review-Todo',



  'Client Review Completed': 'status-client-review-completed',
  ClientReviewCompleted: 'status-client-review-completed',

  'Revision in Progress': 'status-Revision-progress',
  RevisionInProgress: 'status-Revision-progress',

  'Revision ToDo': 'status-Revision-Todo',
  RevisionTodo: 'status-Revision-Todo',

  'Revision Completed': 'status-Revision-completed',
  RevisionCompleted: 'status-Revision-completed',


  'Final Correction in Progress': 'status-final-correction-progress',
  FinalCorrectionInProgress: 'status-final-correction-progress',

  'Final Correction ToDo': 'status-final-correction-Todo',
  FinalCorrectionTodo: 'status-final-correction-Todo',

  'Final Correction Completed': 'status-final-correction-completed',
  FinalCorrectionCompleted: 'status-final-correction-completed',

  'Not In Scope': 'status-Not-In-Scope',
  NotInScope: 'status-Not-In-Scope',

  Released: 'status-released',

  'Completed & Closed': 'status-completed',
  Completed: 'status-completed',

  Cancelled: 'status-cancelled',
  Issues: 'status-issues',

 CompletedAndReleased: "status-completedandreleased",


  NotApplicable1: "status-Drafting-Released",
};
const formatStatusLabel = (status: string) => {
  const overrides: Record<string, string> = {
    Completed: "Ready for Release",
    YetToStart: "Yet to Start",
    NotApplicable: "Not In Scope",
  };

  if (overrides[status]) {
    return overrides[status];
  }

  return status
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/And/g, "&")
    .trim();
};


const childformatStatusLabel = (status: string) => {
  const overrides1: Record<string, string> = {
    Completed: "Completed",
    YetToStart: "Yet to Start",
    NotApplicable: "Not In Scope",
  };

  if (overrides1[status]) {
    return overrides1[status];
  }

  return status
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2")
    .replace(/And/g, "&")
    .trim();
};
const priorityValues = ["Low", "Medium", "High", "Critical"];
const priorityColorMap: Record<string, string> = {
  Low: 'priority-low',
  Medium: 'priority-medium',
  High: 'priority-high',
  Critical: 'priority-critical',
};

const TaskWithSubtaskTable: React.FC = () => {
  const [tasks, setTasks] = useState<TaskList[]>([]);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [expandedTasks, setExpandedTasks] = useState<Record<number, boolean>>({});
  const [editingTaskId, setEditingTaskId] = useState<number | null>(null);
  const [taskEditData, setTaskEditData] = useState<Partial<TaskList>>({});
  const [editingSubtaskId, setEditingSubtaskId] = useState<number | null>(null);
  const [subtaskEditData, setSubtaskEditData] = useState<Partial<SubTaskList>>({});

  const [projectFilter, setProjectFilter] = useState(""); // ""=show cards, "ALL"=all projects, else a project
  const [currentUser, setCurrentUser] = useState<CurrentUser | null>(null); // MODIFIED: State for current user
  const [searchTerm, setSearchTerm] = useState('');
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [selectedLogEntity, setSelectedLogEntity] = useState<{ type: "task" | "subtask" | "child-subtasks"; id: number; title?: string; } | null>(null);
  const [overallLogs, setOverallLogs] = useState<OverallLogDTO[]>([]);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);
  const [extraFilterModalOpen, setExtraFilterModalOpen] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [showCompletedTasks, setShowCompletedTasks] = useState(true);
  const [showReleasedTasks, setShowReleasedTasks] = useState(true);
  const [newRowData, setNewRowData] = useState<TimeSheetRow>({});
  const [selectedTaskForTime, setSelectedTaskForTime] = useState<TaskList | null>(null);
  const queryClient = useQueryClient();
  const [selectedSubTaskForTime, setSelectedSubTaskForTime] = useState<SubTaskList | null>(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const toggleAddModal = () => setAddModalOpen(!addModalOpen);
  const [showNewRow, setShowNewRow] = useState(false);
  const [unreadCounts, setUnreadCounts] = useState<{ [key: string]: number }>({});
  const [totalCommentCount, setTotalCommentCount] = useState<{ [key: string]: number }>({});
  const [showCompletedReleased, setShowCompletedReleased] = useState(true);
  const [showNotInScope, setshowNotInScope] = useState(false);
  const [useWeekdays, setUseWeekdays] = useState(false);
  const [showOnDays, setShowOnDays] = useState(true);
  const [showOnlyMyTasks, setShowOnlyMyTasks] = useState(false);
  const [expandedSubtasks, setExpandedSubtasks] = useState<Record<number, boolean>>({});
  const [editingChildSubtaskId, setEditingChildSubtaskId] = useState<number | null>(null);
  const [childSubtaskEditData, setChildSubtaskEditData] = useState<Partial<ChildSubTask>>({});
  const [selectedChildSubTaskForTime, setSelectedChildSubTaskForTime] = useState<ChildSubTask | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [formErrors, setFormErrors] = useState<any>({});

  const [onHoldModal, setOnHoldModal] = useState(false);
  const [onHoldReason, setOnHoldReason] = useState("");

  const [pendingStatusItem, setPendingStatusItem] =
    useState<{
      type: "task" | "subtask";
      item: any;
      status: string;
    } | null>(null);




  const toDisplayValue = (hours: number) =>
    showOnDays
      ? Math.round(hours)
      : Math.round(hours / 9);
  const unitLabel = showOnDays ? " H" : " ";

  const handleSave = async () => {
    const errors: any = {};

    if (!newRowData.hours) errors.hours = true;
    if (!newRowData.product) errors.product = true;

    if (category === "DRAFTING") {
      if (!newRowData.draftingType) errors.draftingType = true;
      if (!newRowData.quantity) errors.quantity = true;
    }

    // if (!newRowData.description) errors.description = true;

    setFormErrors(errors);

    if (Object.keys(errors).length > 0) return;

    if (isSaving) return; // prevent double click

    setIsSaving(true);

    try {
      await saveRow("new");
      setShowNewRow(false);
    } finally {
      setIsSaving(false);
    }
  };


  //#region columns key

  const [visibleColumns, setVisibleColumns] = useState<string[]>([
    "number", "description", "priority", "assigned", "createdByName",
    "status", "completion", "dueDate", "dueDays",
    "percentCompleted", "comment", "log", "actions", "hours"
  ]);

  const [columns, setColumns] = useState([
    { key: "number", label: "", width: "3%" },
    { key: "description", label: "Task", width: "20%" },
    { key: "maxHours", label: "Max", width: "4%" },
    { key: "spendhours", label: "Spent", width: "4%" },
    { key: "hours", label: "Time", width: "6%" },
    { key: "percentCompleted", label: "Work Done ", width: "6%" },
    { key: "assigned", label: "Assigned To", width: "7%" },
    { key: "createdByName", label: "Assigned By", width: "7%" },
    { key: "status", label: "Status", width: "7%" },
    { key: "priority", label: "Priority", width: "7%" },
    { key: "dueDate", label: "Due Date", width: "7%" },
    { key: "completion", label: "Due ", width: "7%" },
    { key: "comment", label: "chat", width: "6%" },
    { key: "log", label: "Log", width: "6%" },
    { key: "actions", label: "Edit", width: "5%" }
  ]);

  //#endregion

  //#region Drag and Drop
  const [modalPos, setModalPos] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });

  const toggleSubtask = (subtaskId: number) => {
    setExpandedSubtasks(prev => ({
      ...prev,
      [subtaskId]: !prev[subtaskId]
    }));
  };

  const DEFAULT_DUE_COLORS = {
    greaterThan30: "#C8C8C8",   // rgb(200,200,200)
    lessThan30: "#646464",      // rgb(100,100,100)
    lessThan10: "#000000",
    lessThan5: "#0061ff",
    overdue: "#f9001a",
    onTime: "#669c35",
    completed: "#ffffff",
  };


  const [dueColorSettings, setDueColorSettings] = useState(() => {
    const saved = localStorage.getItem("dueColorSettings");
    return saved ? JSON.parse(saved) : DEFAULT_DUE_COLORS;
  });


  const getDueColor = (diff: number, isCompleted: boolean) => {
    if (isCompleted) return dueColorSettings.completed;

    if (diff < 0) return dueColorSettings.overdue;
    if (diff <= 5) return dueColorSettings.lessThan5;
    if (diff <= 10) return dueColorSettings.lessThan10;
    if (diff < 30) return dueColorSettings.lessThan30;

    return dueColorSettings.greaterThan30; // ✅ fixed
  };

  const calculateDiff = (start: Date, end: Date) =>
    useWeekdays
      ? countWeekdaysSigned(start, end)
      : Math.round(
        (end.getTime() - start.getTime()) /
        (1000 * 60 * 60 * 24)
      );






  const handleMouseDown = (e: any) => {
    setDragging(true);
    setOffset({
      x: e.clientX - modalPos.x,
      y: e.clientY - modalPos.y,
    });
  };

  const handleMouseMove = (e: any) => {
    if (!dragging) return;
    setModalPos({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y,
    });
  };

  const handleMouseUp = () => setDragging(false);

  const dragItemIndex = useRef<number | null>(null);

  const handleDragStart = (index: number) => {
    dragItemIndex.current = index;
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault(); // Allow drop
  };

  const handleDrop = (index: number) => {
    if (dragItemIndex.current === null) return;
    const updated = [...columns];
    const [moved] = updated.splice(dragItemIndex.current, 1);
    updated.splice(index, 0, moved);
    setColumns(updated);
    dragItemIndex.current = null;
  };

  //#endregion

  //#region Status Filter

  const allStatuses = [
    "YetToStart",
    "WaitingForInput",
    "Cancelled",
    "OnHold",
    "Issuse",
    "Released",
    "ModellingTodo",
    "DraftingTodo",
    "QCTodo",
    "RevisionTodo",
    "ClientReviewTodo",
    "FinalCorrectionTodo",
    "ModellingInProgress",
    "DraftingInProgress",
    "QCInProgress",
    "RevisionInProgress",
    "ClientReviewInProgress",
    "FinalCorrectionInProgress",
    "ModellingCompleted",
    "DraftingCompleted",
    "QCCompleted",
    "RevisionCompleted",
    "ClientReviewCompleted",
    "FinalCorrectionCompleted",
    // "Completed",
  ];


  const inProgressStatuses = [
    "ModellingInProgress",
    "DraftingInProgress",
    "QCInProgress",
    "RevisionInProgress",
    "ClientReviewInProgress",
    "FinalCorrectionInProgress"
  ];

  const completedStatuses = [
    "ModellingCompleted",
    "DraftingCompleted",
    "QCCompleted",
    "RevisionCompleted",
    "ClientReviewCompleted",
    "FinalCorrectionCompleted",
  ];

  const ToDoStatuses = [
    "ModellingTodo",
    "DraftingTodo",
    "QCTodo",
    "RevisionTodo",
    "ClientReviewTodo",
    "FinalCorrectionTodo"
  ];

  const getStatusOptions = (description?: string) => {
    const desc = description?.toLowerCase() || "";

    if (desc.includes("model")) return MODELLING_STATUSES;
    if (desc.includes("draft")) return DRAFTING_STATUSES;

    return DEFAULT_STATUSES;
  };






  const MODELLING_STATUSES = [
    { value: "NotApplicable", label: "Not In Scope" },
    { value: "YetToStart", label: "Yet to Start" },
    { value: "InProgress", label: "In Progress" },
    { value: "OnHold", label: "On Hold" },
    { value: "ReadyForReview", label: "Ready for Review" },
    { value: "ReviewInProgress", label: "Review in Progress" },
    { value: "ChangesRequested", label: "Changes Requested" },
    { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
    { value: "CompletedAndApproved", label: "Completed & Approved" },
  ];

  const DRAFTING_STATUSES = [
    { value: "NotApplicable", label: "Not In Scope" },
    { value: "YetToStart", label: "Yet to Start" },
    { value: "InProgress", label: "In Progress" },
    { value: "OnHold", label: "On Hold" },
    { value: "ReadyForReview", label: "Ready for Review" },
    { value: "ReviewInProgress", label: "Review in Progress" },
    { value: "ReworkCorrectionInProgress", label: "Rework / Correction in Progress" },
    { value: "ReadyToRelease", label: "Ready to Release" },
    { value: "CompletedAndReleased", label: "Completed" },

  ];

  const DEFAULT_STATUSES = [
    { value: "NotApplicable", label: "Not In Scope" },
    { value: "YetToStart", label: "Yet to Start" },
    { value: "InProgress", label: "In Progress" },
    { value: "OnHold", label: "On Hold" },
    { value: "Completed", label: "Completed" },

  ];








  //#endregion

  //#region  Comments
  const [commentPopup, setCommentPopup] = useState<{
    open: boolean;
    type: "project" | "task" | "subtask" | "childSubTask";
    id: number;
    title?: string;
  } | null>(null);


  const openComments = (
    type: "project" | "task" | "subtask" | "childSubTask",
    id: number,
    title?: string
  ) => {
    setCommentPopup({
      open: true,
      type,
      id,
      title
    });
  };


  const loadUnreadCountFor = async (
    type: "task" | "subtask" | "childSubTask",
    id: number
  ) => {

    const key = `${type[0]}-${id}`;

    // ⛔ If we already have unread > 0 in storage → do NOT fetch & overwrite
    if (unreadCounts[key] > 0) return;

    try {
      const count = await getUnreadCount(type, id);

      // save only if API returns more unread than saved
      setUnreadCounts(prev => {
        const updated = {
          ...prev,
          [key]: Math.max(prev[key] ?? 0, count)
        };
        localStorage.setItem("unreadCounts", JSON.stringify(updated));
        return updated;
      });

    } catch {
      console.warn("Unread load failed, using saved value");
    }
  };




  // 🔹 Load total comments count (task / subtask)
  const loadTotalCommentsFor = async (type: "task" | "subtask", id: number) => {
    const key = `${type[0]}-${id}`;

    try {
      const comments = await getComments(type, id);
      const total = comments.length;

      setTotalCommentCount(prev => {
        const updated = { ...prev, [key]: total };
        localStorage.setItem("totalCommentCount", JSON.stringify(updated));
        return updated;
      });

    } catch {
      setTotalCommentCount(prev => {
        const updated = { ...prev, [key]: 0 };
        localStorage.setItem("totalCommentCount", JSON.stringify(updated));
        return updated;
      });
    }
  }


  useEffect(() => {
    const savedUnread = localStorage.getItem("unreadCounts");
    if (savedUnread) setUnreadCounts(JSON.parse(savedUnread));

    const savedTotal = localStorage.getItem("totalCommentCount");
    if (savedTotal) setTotalCommentCount(JSON.parse(savedTotal));

    loadTasks(); // fetch tasks later, unread won't reset
  }, []);


  useEffect(() => {
    const loggedInUser: CurrentUser = {

      id: userID || "", // <-- Replace with the real user's ID
      name: name || ""    // <-- Replace with the real user's name
    };
    setCurrentUser(loggedInUser);

    loadTasks();
  }, []);


  async function loadTasks() {
    setLoadingTasks(true);

    try {
      const [taskRes, childRes] = await Promise.all([
        getMyTasks(),
        getMyChildSubTasks()
      ]);

      const tasksRaw = Array.isArray(taskRes) ? taskRes : taskRes?.$values || [];

      const childList: any[] =
        Array.isArray(childRes?.data) ? childRes.data : childRes?.data?.$values || [];

      // 1️⃣ Group children by subTaskId
      const childMap = new Map<number, ChildSubTask[]>();

      childList.forEach(child => {
        const parentId = child.subTaskId; // ✅ confirmed backend key

        if (!parentId) return;

        if (!childMap.has(parentId)) {
          childMap.set(parentId, []);
        }

        childMap.get(parentId)!.push({
          ...child,
          assignedToName: child.assignedToName || "—",
          createdByName: child.createdByName || "—",
          priority: child.priority || "Medium",
          dueDate: child.dueDate || null
        });
      });

      // 2️⃣ Attach to subtasks
      const taskArray: TaskList[] = tasksRaw.map((t: any) => ({
        ...t,
        assignedToName: t.assignedToName || "—",
        createdByName: t.createdByName || "—",
        priority: t.priority || "Medium",
        dueDate: t.dueDate || null,

        subTasks: (t.subTasks || []).map((s: any) => ({
          ...s,
          assignedToName: s.assignedToName || "—",
          createdByName: s.createdByName || "—",
          priority: s.priority || "Medium",
          dueDate: s.dueDate || null,

          // ✅ HERE is the magic
          childSubTasks: childMap.get(s.id) || []
        }))
      }));

      setTasks(taskArray);

    } catch (err) {
      console.error(err);
      toast.error("Failed to load tasks");
    } finally {
      setLoadingTasks(false);
    }
  }


  useEffect(() => {
    if (newRowData.product === "Drafting Update") {
      setNewRowData(prev => ({
        ...prev,
        quantity: prev.quantity ?? 1,
      }));
    }
  }, [newRowData.product]);



  useEffect(() => {
    if (!tasks.length) return;

    tasks.forEach(task => {
      loadUnreadCountFor("task", task.id);

      task.subTasks?.forEach(st => {
        loadUnreadCountFor("subtask", st.id);

        st.childSubTasks?.forEach(child => {
          loadUnreadCountFor("childSubTask", child.id); // ✅ ADD THIS
        });
      });
    });
  }, [projectFilter]);


  //#endregion

  //#region Logs

  const loadOverallLogs = async (entityType: "task" | "subtask" | "child-subtasks", entityId: number) => {
    try {
      let logs: OverallLogDTO[] = [];

      if (entityType === "task") {
        logs = await getTaskLogs(entityId);  // already returns array
      } else {
        logs = await getSubTaskLogs(entityId);
      }

      setOverallLogs(logs);
      setLogModalOpen(true);
    } catch (err) {
      console.error("Failed to load overall logs:", err);
      setOverallLogs([]);
    }
  };

  //#endregion

  const projectNames = Array.from(
    new Set(tasks.map((task) => task.projectName).filter(Boolean))
  );
  const norm = (s: string = "") =>
    s.replace(/\s+/g, "").toLowerCase();

  const totalTasks = tasks.length;
  const completedTasks = tasks.filter(t =>
    ["released", "completed", "completed&closed"].includes(norm(t.status))
  ).length;

  // IN PROGRESS = Modelling + Drafting
  const inProgressTasks = tasks.filter(t =>
    ["modellinginprogress", "draftinginprogress", "finalcorrectioninprogress"].includes(norm(t.status))
  ).length;

  // YET TO START
  const yetToStartTasks = tasks.filter(t =>
    norm(t.status) === "yettostart"
  ).length;

  // IN QC
  const inQcTasks = tasks.filter(t =>
    norm(t.status) === "qcinprogress"
  ).length;

  // CLIENT REVIEW
  const clientReviewTasks = tasks.filter(t =>
    norm(t.status) === "clientreviewinprogress"
  ).length;
  const { userID, name } = useAuth();



  //#region All filter Condition

  const normalizeStatus = (s: string) =>
    s.replace(/\s+/g, "").replace(/&/g, "").toLowerCase();

  let filteredTasks: TaskList[] = [];

  // PROJECT FILTER
  if (projectFilter === "ALL") {
    filteredTasks = tasks;
  } else if (projectFilter) {
    filteredTasks = tasks.filter((task) => task.projectName === projectFilter);
  } else {
    filteredTasks = [...tasks];
  }

  // SEARCH FILTER
  if (searchTerm.trim()) {
    const lower = searchTerm.toLowerCase();
    filteredTasks = filteredTasks.filter((task) => {
      const assignedName = task.assignedToName?.toLowerCase() || "";

      const taskMatches =
        assignedName.includes(lower) ||
        task.description?.toLowerCase().includes(lower) ||
        task.status?.toLowerCase().includes(lower) ||
        task.dueDate?.toLowerCase().includes(lower) ||
        task.priority?.toLowerCase().includes(lower);

      const subtaskMatches = task.subTasks?.some((st) =>
        st.description?.toLowerCase().includes(lower) ||
        st.status?.toLowerCase().includes(lower) ||
        st.dueDate?.toLowerCase().includes(lower) ||
        st.priority?.toLowerCase().includes(lower) ||
        st.assignedToName?.toLowerCase().includes(lower)
      );

      return taskMatches || subtaskMatches;
    });
  }

  // ==========================
  // ✅ STATUS FILTER (TASK + SUBTASK)
  // ==========================
  if (selectedStatuses.length > 0) {
    const normalizedSelected = selectedStatuses.map(s => normalizeStatus(s));

    filteredTasks = filteredTasks
      .map(task => {
        const taskMatches = normalizedSelected.includes(normalizeStatus(task.status));

        const matchingSubtasks = task.subTasks?.filter(st =>
          normalizedSelected.includes(normalizeStatus(st.status))
        ) || [];

        // CASE 1: Only Task matches → show task with NO subtasks
        if (taskMatches && matchingSubtasks.length === 0) {
          return { ...task, subTasks: [] };
        }

        // CASE 2: Subtasks match (task may match or not) → show ONLY subtasks
        if (matchingSubtasks.length > 0) {
          return { ...task, subTasks: matchingSubtasks };
        }

        // CASE 3: Nothing matches -> remove task
        return null;
      })
      .filter(Boolean) as TaskList[];
  }

  // ✅ Sort tasks so Completed go last
  filteredTasks = filteredTasks.sort((a, b) => {
    const isAClosed = a.status === "Completed" || a.status === "Completed & Closed";
    const isBClosed = b.status === "Completed" || b.status === "Completed & Closed";

    if (isAClosed && !isBClosed) return 1;  // push A down
    if (!isAClosed && isBClosed) return -1; // keep A above B
    return 0; // keep original order for others
  });

  // ✅ Sort subtasks so only Completed go last
  filteredTasks = filteredTasks.map(task => ({
    ...task,
    subTasks: task.subTasks
      ? [...task.subTasks].sort((a, b) => {
        const isAClosed = a.status === "Completed" || a.status === "Completed & Closed";
        const isBClosed = b.status === "Completed" || b.status === "Completed & Closed";

        if (isAClosed && !isBClosed) return 1;  // push A down
        if (!isAClosed && isBClosed) return -1; // keep A above
        return 0; // ⚡ do NOT change order of other statuses
      })
      : []
  }));


  const toUtcIso = (dateStr: string | null) => {
    if (!dateStr) return null;
    const date = new Date(dateStr + "T00:00:00");
    return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString();
  };

  // --- SEARCH FILTER ---
  if (searchTerm.trim()) {
    const lower = searchTerm.toLowerCase();
    filteredTasks = filteredTasks.filter(task => {
      const assignedName = task.assignedToName?.toLowerCase() || "";
      const descriptionMatch = task.description?.toLowerCase().includes(lower);
      const statusMatch = task.status?.toLowerCase().includes(lower);
      const priorityMatch = task.priority?.toLowerCase().includes(lower);
      const nameMatch = assignedName.includes(lower);
      const duedatematch = task.dueDate.toLowerCase().includes(lower);

      return nameMatch || descriptionMatch || statusMatch || priorityMatch || duedatematch;
    });
  }

  //#endregion

  //#region Edit Task Subtask

  const startTaskEdit = (task: TaskList) => {
    setEditingTaskId(task.id);
    setTaskEditData({
      ...task,
      dueDate: task.dueDate?.slice(0, 10),
      completionDate: task.completionDate?.slice(0, 10),
      status: task.status || "YetToStart",
      priority: task.priority || "Medium",
    });
    setEditingSubtaskId(null);
  };
  const cancelTaskEdit = () => {
    setEditingTaskId(null);
    setTaskEditData({});
  };
  const onTaskChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;

    setTaskEditData((prev) => {
      let updated = {
        ...prev,
        [name]: name === "percentCompleted" ? Number(value) || 0 : value,
      };

      // Status → Percent Map
      const statusPercentMap: Record<string, number> = {
        ModellingCompleted: 30,
        DraftingCompleted: 60,
        QCCompleted: 70,
        ClientReviewCompleted: 80,
        FinalCorrectionCompleted: 90,
      };

      // When status changes
      if (name === "status") {
        const today = new Date().toISOString().slice(0, 10);
        updated.completionDate = today;

        // Auto apply percent based on status
        if (statusPercentMap[value] !== undefined) {
          updated.percentCompleted = statusPercentMap[value];
        }

        // Full complete states → 100%
        if (
          value === "Completed" ||
          value === "Completed" ||
          value === "Released"
        ) {
          updated.percentCompleted = 100;
        }
      }

      return updated;
    });
  };




  const saveTask = async () => {
    if (!editingTaskId) return;

    // Basic field validation
    // if (!taskEditData.description || !taskEditData.dueDate || !taskEditData.status) {
    //   toast.error("Please fill required fields: description, due date, and status");
    //   return;
    // }

    // Build payload
    const taskPayload: any = {
      description: taskEditData.description,
      dueDate: toUtcIso(taskEditData.dueDate || null),
      status: taskEditData.status,
      priority: taskEditData.priority,
      percentCompleted: taskEditData.percentCompleted ?? 0,
      spentHours: taskEditData.spentHours,
      remarks: taskEditData.remarks,
      issues: taskEditData.issues,
      completionDate: toUtcIso(taskEditData.completionDate || new Date().toISOString().slice(0, 10))
    };


    try {
      await updateMyTask(editingTaskId, taskPayload);
      toast.success("Task updated successfully");
      setEditingTaskId(null);
      setTaskEditData({});
      await loadTasks();
    } catch (error: any) {
      console.error("Error updating task:", error);
      if (error.response?.status === 400) {
        toast.error(error.response.data?.message || "Bad Request: Please check your input fields.");
      } else {
        toast.error("Failed to update task. Please try again.");
      }
    }
  };


  const startSubtaskEdit = (subtask: SubTaskList) => {
    setEditingSubtaskId(subtask.id);
    setSubtaskEditData({
      ...subtask,
      dueDate: subtask.dueDate?.slice(0, 10),
      completionDate: subtask.completionDate?.slice(0, 10) || "",
      priority: subtask.priority || "Medium",
      status: subtask.status || "YetToStart",
      spentHours: subtask.spentHours
    });
    setEditingTaskId(null); // If you have task editing too
  };



  const cancelSubtaskEdit = () => {
    setEditingSubtaskId(null);
    setSubtaskEditData({});
  };

  const onSubtaskChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setSubtaskEditData((prev) => {
      let updated: any = {
        ...prev,
        [name]: name === "percentCompleted" ? Number(value) || 0 : value,
      };

      // Status → Percent Auto Map
      const statusPercentMap: Record<string, number> = {
        ModellingCompleted: 30,
        DraftingCompleted: 40,
        QCCompleted: 50,
        RevisionCompleted: 60,
        ClientReviewCompleted: 70,
        FinalCorrectionCompleted: 80,
        Released: 100,
        Completed: 98,
        "All Completed": 98,
      };

      // =============================
      // 🔥 Subtask Percentage Changed
      // =============================
      if (name === "percentCompleted") {
        if (updated.percentCompleted === 100) {
          updated.status = "Released";
          updated.completionDate = new Date().toISOString().slice(0, 10);
        }
        return updated;
      }

      // =============================
      // 🔥 Subtask Status Changed
      // =============================
      if (name === "status") {
        const today = new Date().toISOString().slice(0, 10);
        updated.completionDate = today;

        // auto percent based on status mapping
        if (statusPercentMap[value] !== undefined) {
          updated.percentCompleted = statusPercentMap[value];
        }

        return updated;
      }

      return updated;
    });
  };

  //#endregion


  const handleStatusChangeWithReason = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    item: any,
    type: "task" | "subtask"
  ) => {

    const value = e.target.value;

    // 🔥 ON HOLD
    if (value === "OnHold") {

      setPendingStatusItem({
        type,
        item,
        status: value
      });

      setOnHoldReason("");
      setOnHoldModal(true);

      return;
    }

    // 🔥 NORMAL FLOW
    if (type === "task") {
      onTaskChange(e as any);
    } else {
      onSubtaskChange(e as any);
    }
  };



  const saveOnHoldReason = async () => {

    if (!onHoldReason.trim()) {
      toast.error("Reason is required");
      return;
    }

    try {

      // 🔥 SAVE COMMENT
      await addComment({
        entityType:
          pendingStatusItem?.type === "task"
            ? "Task"
            : "SubTask",

        entityId: pendingStatusItem?.item?.id,

        content: onHoldReason.trim()
      });

      if (pendingStatusItem?.type === "task") {

        setTaskEditData((prev: any) => ({
          ...prev,
          status: pendingStatusItem?.status || ""
        }));

      } else {

        setSubtaskEditData((prev: any) => ({
          ...prev,
          status: pendingStatusItem?.status || ""
        }));
      }

      toast.success("Status updated");

      setOnHoldModal(false);

      setPendingStatusItem(null);

    } catch (err: any) {

      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        "Failed to save reason"
      );
    }
  };



  //#region Expand
  const toggleTask = (taskId: number) => {
    setExpandedTasks((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  //#endregion
  // ==========================
  // #region SHOW ONLY MY TASKS
  // ==========================
  if (showOnlyMyTasks && currentUser) {
    filteredTasks = filteredTasks
      .map(task => {
        const isMyTask = task.assignedToName === currentUser.name;

        const mySubTasks =
          task.subTasks?.filter(
            st => st.assignedToName === currentUser.name
          ) || [];

        // ✅ Case 1: Task assigned to me → show task + ONLY my subtasks
        if (isMyTask) {
          return {
            ...task,
            subTasks: mySubTasks
          };
        }

        // ✅ Case 2: Task NOT assigned to me but subtask is → show ONLY those subtasks
        if (mySubTasks.length > 0) {
          return {
            ...task,
            subTasks: mySubTasks
          };
        }

        // ❌ Case 3: Nothing assigned to me → remove task
        return null;
      })
      .filter(Boolean) as TaskList[];
  }

  useEffect(() => {
    if (!showOnlyMyTasks) return;

    const expanded: Record<number, boolean> = {};
    filteredTasks.forEach(t => {
      if (t.subTasks && t.subTasks.length > 0) {
        expanded[t.id] = true;
      }
    });
    setExpandedTasks(expanded);
  }, [showOnlyMyTasks]);


  //#region  Worksheet 

  const hourOptions = [0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8, 8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12];
  const moduleOptions = [
    "Bracings Connections",
    "Cladding Structure",
    "Damper duct Electrical kit assy on site",
    "Electrical Ex-works",
    "Electrical kit assy on site",
    "Elbow Duct",
    "EVAP Cooler",
    "Filter House",
    "Flexible Bellow",
    "Gaskets",
    "Gratings",
    "Handrail Connections",
    "Hardware Connections",
    "Heating Coil",
    "Hoist Assembly",
    "Inlet Bleed Heat Duct",
    "Inlet Hood",
    "Ladder Assembly",
    "Lifting Sketches",
    "Made from electrical kit",
    "Piping Kit",
    "Pump Basket",
    "Pump skid electrical assy on site",
    "Pneumatic Kit assy on site",
    "Second Stage",
    "Silencer Duct",
    "Stair Tower Assembly",
    "Straight Duct",
    "Straight Duct (Data Weldment)",
    "Table Top Structure",
    "Teamcenter Release/Handling",
    "Transition Duct (Data Weldment)",
    "Transition Duct (Modelling)",
    "Transportation Drawing",
    "Vertical Duct",
    "Others"
  ];

  const modellingOptions = [
    "Modelling",
    "Modelling Update",
    "Modelling Review"
  ];

  const draftingOptions = [
    "Drafting",
    "Drafting Update",
    "Drafting Review"
  ];

  const otherOptions = [
    "Others",
    "CP request",
    "Release",
    "Training",
    "Teamcentre",
    "Client Meeting",
    "Management",
    "ISO"
  ];



  const getTaskTypeOptions = (childName?: string) => {
    if (!childName) return [];

    const text = childName.toLowerCase();

    if (text.includes("model")) return modellingOptions;
    if (text.includes("draft")) return draftingOptions;

    return otherOptions;
  };


  const drawingTypeOptions = [
    { code: "6MM", label: "6MM", full: "Standard 6 mm thickness part drawing" },

    { code: "2SG", label: "2SG", full: "2 Subgroup assembly drawing " },

    { code: "3EA", label: "3EA", full: "3 Element assembly (Extended) " },

    { code: "4MA", label: "4MA", full: "4 Member assembly drawing " },

    { code: "8PP", label: "8PP", full: "8 Part package drawing " },

    { code: "COMP-WELD", label: "COMP-WELD", full: "Complicated weldments drawing " },

    { code: "1FA", label: "1FA" },

    { code: "Others", label: "Other" },
  ];

  const assignedByOptions = ['ElaiyaPerumal', 'Santhosh S', 'Santhosh R', 'Renganathan', 'Umesh', 'Vishal', 'Sabari', 'Sengamuthu'];



  const mutation = useMutation({
    mutationFn: (dto: CreateTimeSheetDTO | { timeId: string; dto: CreateTimeSheetDTO }) => {
      if ('timeId' in dto) return updateTimeSheet(dto.timeId, dto.dto).then((res) => res.data);
      return createTimeSheet(dto as CreateTimeSheetDTO).then((res) => res.data);
    },
    onSuccess: (saved) => {
      queryClient.invalidateQueries({ queryKey: ['timesheets'] });
      setNewRowData({});
      toast.success('Timesheet saved successfully!');
    },
    onError: (error: any) => {
      console.error('Full error object:', error);

      const responseData = error?.response?.data;
      console.log('Backend error response:', responseData);

      const message =
        responseData?.message ||
        responseData?.error ||
        error?.message ||
        'Something went wrong. Please try again.';

      toast.error(message);
    },
  });


  useEffect(() => {
    if (!selectedTaskForTime) return;

    setNewRowData(prev => ({
      ...prev,
      taskId: selectedTaskForTime.id,
      taskDescription: selectedTaskForTime.description,
      projectName: selectedTaskForTime.projectName,
      createdByName: selectedTaskForTime?.createdByName,

    }));
  }, [selectedTaskForTime]);


  useEffect(() => {
    setNewRowData(prev => ({
      ...prev,
      subTaskId: selectedSubTaskForTime?.id,
      subTaskDescription: selectedSubTaskForTime?.description,
      createdByName: selectedSubTaskForTime?.createdByName,
    }));
  }, [selectedSubTaskForTime]);

  useEffect(() => {
    if (!selectedChildSubTaskForTime) return;

    setNewRowData(prev => ({
      ...prev,
      childSubTaskDescription: selectedChildSubTaskForTime.description
    }));
  }, [selectedChildSubTaskForTime]);





  const saveRow = async (rowId: string) => {
    if (!newRowData.projectName || !newRowData.hours || !newRowData.createdByName) {
      toast.error("Please fill all required fields.");
      return;
    }

    const dto: CreateTimeSheetDTO = {
      date: new Date().toISOString().split("T")[0],
      projectName: newRowData.projectName,
      hours: newRowData.hours,
      assignedBy: newRowData.createdByName,
      description: newRowData.description ?? null, // remarks only
      module: newRowData.taskDescription,
      product: newRowData.product,
      subTask: newRowData.subTaskDescription ?? null,
      childSubTask: newRowData.childSubTaskDescription ?? null,
      part: newRowData.part,
      draftingType: newRowData.draftingType ?? null,
      quantity: newRowData.quantity ?? null,
      totPages: newRowData.totPages ?? null,
    };

    try {
      // 1️⃣ Save timesheet
      await mutation.mutateAsync(dto);

      // 2️⃣ 🔥 ADD HOURS TO SPENT HOURS
      await addSpentHours(newRowData.hours);

      // 3️⃣ Reload task list
      await loadTasks();

      // 4️⃣ Cleanup
      toggleAddModal();
      setNewRowData({});
      setSelectedTaskForTime(null);
      setSelectedSubTaskForTime(null);

    } catch (err) {
      console.error(err);
    }
  };


  //#endregion

  const saveSubtask = async () => {
    if (!editingSubtaskId) return;

    // if (!subtaskEditData.description || !subtaskEditData.dueDate || !subtaskEditData.status) {
    //   toast.error("Please fill required fields: description, due date, and status");
    //   return;
    // }

    // Build payload with UTC-safe dates
    const subtaskPayload: any = {
      description: subtaskEditData.description,
      dueDate: toUtcIso(subtaskEditData.dueDate || null),
      status: subtaskEditData.status,
      spentHours: subtaskEditData.spentHours,
      priority: subtaskEditData.priority,
      percentCompleted: subtaskEditData.percentCompleted ?? 0,
      workHours: subtaskEditData.workHours,
      remarks: subtaskEditData.remarks,
      issues: subtaskEditData.issues,
      completionDate: toUtcIso(subtaskEditData.completionDate || new Date().toISOString().slice(0, 10))
    };


    try {
      await updateMySubTask(editingSubtaskId, subtaskPayload);
      toast.success("Subtask updated successfully");
      setEditingSubtaskId(null);
      setSubtaskEditData({});
      await loadTasks();
    } catch (error: any) {
      console.error("Error updating subtask:", error);
      if (error.response?.status === 400) {
        toast.error(error.response.data?.message || "Bad Request: Please check your input fields.");
      } else {
        toast.error("Failed to update subtask. Please try again.");
      }
    }
  };

  //#region Date format

  const formatDate = (dateStr: string | undefined | null): string => {
    if (!dateStr) return "—";

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const d = new Date(dateStr);

    if (isNaN(d.getTime())) return "—";

    const day = d.getDate();            // ✅ LOCAL date
    const monthName = months[d.getMonth()];
    const year = d.getFullYear();

    return `${day}-${monthName}-${year}`;
  };


  //#endregion

  //#region hide columns storage 

  useEffect(() => {
    const savedColumns = localStorage.getItem("visibleColumns");
    if (savedColumns) setVisibleColumns(JSON.parse(savedColumns));

    const savedReleased = localStorage.getItem("showCompletedReleased");
    if (savedReleased) setShowCompletedReleased(savedReleased === "true");

    const savednot = localStorage.getItem("showNotInScope");
    if (savednot) setshowNotInScope(savednot === "true");


    const savedShowOnDays = localStorage.getItem("showOnDays");
    if (savedShowOnDays) setShowOnDays(savedShowOnDays === "true");

  }, []);

  //#endregion

  const projectStatusOptions = [
    { value: "YetToStart", label: "Yet to Start" },
    { value: "WaitingForInput", label: "Waiting for Input" },
    { value: "", label: "" },
    { value: "ModellingTodo", label: "Modelling ToDo" },
    { value: "ModellingInProgress", label: "Modelling in Progress" },
    { value: "ModellingCompleted", label: "Modelling Completed" },
    { value: "", label: "" },
    { value: "DraftingTodo", label: "Drafting ToDo" },
    { value: "DraftingInProgress", label: "Drafting in Progress" },
    { value: "DraftingCompleted", label: "Drafting Completed" },
    { value: "", label: "" },
    { value: "QCTodo", label: "QC ToDo" },
    { value: "QCInProgress", label: "QC in Progress" },
    { value: "QCCompleted", label: "QC Completed" },
    { value: "", label: "" },
    { value: "ClientReviewTodo", label: "Client Review ToDo" },
    { value: "ClientReviewInProgress", label: "Client Review in Progress" },
    { value: "ClientReviewCompleted", label: "Client Review Completed" },
    { value: "", label: "" },
    { value: "FinalCorrectionTodo", label: "Final Correction ToDo" },
    { value: "FinalCorrectionInProgress", label: "Final Correction in Progress" },
    { value: "FinalCorrectionCompleted", label: "Final Correction Completed" },
    { value: "", label: "" },
    { value: "RevisionTodo", label: "Revision ToDo" },
    { value: "RevisionInProgress", label: "Revision in Progress" },
    { value: "RevisionCompleted", label: "Revision Completed" },
    { value: "", label: "" },
    { value: "Cancelled", label: "Cancelled" },
    { value: 'Issues', label: 'Issues' },
    { value: "OnHold", label: "On Hold" },
    { value: "Released", label: "Released" },
    { value: "NotInScope", label: "Not In Scope" },
    { value: "Completed", label: "Ready for Release" },

  ];

  //#region count only working days 
  function workingDaysBetween(start: Date, end: Date) {
    let count = 0;
    let current = new Date(start);

    current.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    while (current < end) {
      const day = current.getDay();
      if (day !== 0 && day !== 6) count++;   // exclude Sunday(0) & Saturday(6)
      current.setDate(current.getDate() + 1);
    }

    while (current > end) { // When completed before due date
      const day = current.getDay();
      if (day !== 0 && day !== 6) count--;
      current.setDate(current.getDate() - 1);
    }

    return count;
  }

  const countWeekdaysSigned = (start: Date, end: Date) => {
    const a = new Date(start);
    const b = new Date(end);
    a.setHours(0, 0, 0, 0);
    b.setHours(0, 0, 0, 0);

    if (a.getTime() === b.getTime()) return 0;

    const forward = b > a;
    let d = new Date(a);
    let count = 0;

    d.setDate(d.getDate() + (forward ? 1 : -1));

    while (forward ? d <= b : d >= b) {
      const day = d.getDay(); // 0=Sun, 6=Sat
      if (day !== 0 && day !== 6) {
        count += forward ? 1 : -1;
      }
      d.setDate(d.getDate() + (forward ? 1 : -1));
    }

    return count;
  };

  const addSpentHours = async (hours: number) => {

    // CHILD SUBTASK (highest priority)
    if (selectedChildSubTaskForTime) {
      const updatedSpent =
        (selectedChildSubTaskForTime.spentHours ?? 0) + hours;

      await updateMyChildSubTask(selectedChildSubTaskForTime.id, {
        spentHours: updatedSpent
      });

      return;
    }

    // SUBTASK
    if (selectedSubTaskForTime) {
      const updatedSpent =
        (selectedSubTaskForTime.spentHours ?? 0) + hours;

      await updateMySubTask(selectedSubTaskForTime.id, {
        spentHours: updatedSpent,
      });

      return;
    }

    // TASK
    if (selectedTaskForTime) {
      const updatedSpent =
        (selectedTaskForTime.spentHours ?? 0) + hours;

      await updateMyTask(selectedTaskForTime.id, {
        spentHours: updatedSpent,
      });
    }
  };


  //#endregion


  const startChildSubtaskEdit = (child: ChildSubTask) => {
    setEditingChildSubtaskId(child.id);
    setChildSubtaskEditData({
      ...child
    });
  };

  const cancelChildSubtaskEdit = () => {
    setEditingChildSubtaskId(null);
    setChildSubtaskEditData({});
  };

  const onChildSubtaskChange = (e: any) => {
    const { name, value } = e.target;
    setChildSubtaskEditData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const saveChildSubtask = async () => {
    if (!editingChildSubtaskId) return;

    const payload: ChildSubTaskUpdateTMDto = {
      spentHours: childSubtaskEditData.spentHours,
      percentCompleted: childSubtaskEditData.percentCompleted,
      status: childSubtaskEditData.status,
      remarks: childSubtaskEditData.remarks,
      completionDate: childSubtaskEditData.completionDate || null
    };

    try {
      await updateMyChildSubTask(editingChildSubtaskId, payload);
      toast.success("Child subtask updated");

      setEditingChildSubtaskId(null);
      setChildSubtaskEditData({});
      await loadTasks();
    } catch (e) {
      toast.error("Failed to update child subtask");
    }
  };


  const getChildTotal = (children: ChildSubTask[] = []) => {
    return children.reduce((sum, c) => sum + (Number(c.spentHours) || 0), 0);
  };

  const getSubtaskTotal = (subtask: SubTaskList) => {
    return getChildTotal(subtask.childSubTasks || []);
  };

  const getTaskTotal = (task: TaskList) => {
    return (task.subTasks || []).reduce(
      (sum, st) => sum + getSubtaskTotal(st),
      0
    );
  };

  const getMaxChildTotal = (children: ChildSubTask[] = []) => {
    return children.reduce((sum, c) => sum + (Number(c.maxHours) || 0), 0);
  };

  const getMaxSubtaskTotal = (subtask: SubTaskList) => {
    return getMaxChildTotal(subtask.childSubTasks || []);
  };

  const getMaxTaskTotal = (task: TaskList) => {
    return (task.subTasks || []).reduce(
      (sum, st) => sum + getMaxSubtaskTotal(st),
      0
    );
  };

  const getInitials = (name: string) => {
    const parts = name.trim().split(" ");
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };


  const UserAvatar = ({ name }: { name: string }) => {
    const initials = getInitials(name);

    return (
      <div
        title={name}
        style={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: "#008BFF",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 600,
          marginRight: 4,
          cursor: "default",
        }}
      >
        {initials}
      </div>
    );
  };


  type WorkCategory = "MODELLING" | "DRAFTING" | "OTHER";

  const getWorkCategory = (desc?: string): WorkCategory => {
    if (!desc) return "OTHER";

    const d = desc.toLowerCase();

    if (d.includes("model")) return "MODELLING";
    if (d.includes("draft")) return "DRAFTING";

    return "OTHER";
  };


  const category = getWorkCategory(newRowData.childSubTaskDescription);

  const hoursLabel =
    category === "MODELLING"
      ? "Modelling Hours"
      : category === "DRAFTING"
        ? "Drafting Hours"
        : "Hours";

  const typeLabel =
    category === "MODELLING"
      ? "Modelling Type"
      : category === "DRAFTING"
        ? "Drafting Type"
        : "Type";











  return (
    <Container fluid className="mt-4">

      <Row className="align-items-center g-3">

        {/* 🔽 Project Select */}
        <Col xs={12} sm={6} lg={2}>
          <FormGroup className="mb-0">
            <Input
              type="select"
              value={projectFilter}
              onChange={(e) => setProjectFilter(e.target.value)}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Project</option>
              <option value="ALL">All Projects</option>
              {projectNames.map((name) => (
                <option key={name} value={name}>{name}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>

        {/* 🏷 Status Filter */}
        {tasks.length > 0 && (
          <Col xs={12} sm={6} lg={3}>
            <div className="d-flex gap-2">
              <Button
                color="primary"
                outline
                className="rounded-pill px-3"
                onClick={() => setStatusModalOpen(true)}
              >
                Filter Status
              </Button>

              <Button
                color="secondary"
                outline
                className="rounded-pill px-3"
                onClick={() => {
                  setSelectedStatuses([]);
                  setExtraFilterModalOpen(false);
                }}
              >
                Clear
              </Button>
              <Button
                color={showOnlyMyTasks ? "primary" : "secondary"}
                outline
                className="rounded-pill px-3"
                onClick={() => setShowOnlyMyTasks(prev => !prev)}
              >
                {showOnlyMyTasks ? "Show All Tasks" : "Show My Tasks"}
              </Button>

            </div>
          </Col>


        )}

        {/* ⚙ Settings */}
        <Col xs={12} sm={2} lg={1} className="text-start text-lg-center">
          <SettingsIcon
            onClick={() => setSettingsOpen(true)}
            style={{
              cursor: "pointer",
              fontSize: "26px",
              color: "#6c757d",
            }}
            className="hover-scale"
          />
        </Col>

        {/* 🔍 Search */}
        <Col xs={12} sm={6} lg={3}>
          <InputGroup className="shadow-sm rounded-pill overflow-hidden">
            <InputGroupText className="bg-white border-0">
              <PersonSearchIcon />
            </InputGroupText>
            <Input
              placeholder="Search by task name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border-0"
            />
          </InputGroup>
        </Col>

      </Row>




      {/* ===== Project Status Cards ===== */}
      {/* {(projectFilter === "" || projectFilter === "ALL") && (
        <Row className="g-4 mb-4">
          {[
            { title: "Total Tasks", value: totalTasks, icon: <ListTask size={28} color="#0e00d8ff" />, bg: "linear-gradient(135deg,#dbeafe,#93c5fd)" },
            { title: "Completed", value: completedTasks, icon: <CheckCircle size={28} color="#198754" />, bg: "linear-gradient(135deg,#d1fae5,#6ee7b7)" },
            { title: "In Progress", value: inProgressTasks, icon: <ClipboardCheck size={28} color="#ffc107" />, bg: "linear-gradient(135deg,#fef9c3,#facc15)" },
            { title: "Yet To Start", value: yetToStartTasks , icon: <Clock size={28} color="#f81302ff" />, bg: "linear-gradient(135deg,#fee2e2,#ef4444)" },
            { title: "In Qc", value: inQcTasks , icon: <Rocket size={28} color="#037e1eff" />, bg: "linear-gradient(135deg,#ecfccb,#84cc16)" },
            { title: "In Client", value: clientReviewTasks , icon: <HourglassSplit size={28} color="#0dcaf0" />, bg: "linear-gradient(135deg,#e0f2fe,#38bdf8)" },
          ].map((stat, idx) => (
            <Col sm={6} md={4} lg={2} key={idx}>
              <Card
                body
                className="text-center shadow-sm border-0 stat-card"
                style={{
                  borderRadius: "20px",
                  background: "rgba(255, 255, 255, 0.7)",
                  backdropFilter: "blur(8px)",
                  transition: "all 0.3s ease-in-out",
                  cursor: "pointer",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center mb-2"
                  style={{
                    background: stat.bg,
                    borderRadius: "16px",
                    padding: "12px 16px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    width: "100%",
                    justifyContent: "flex-start",
                  }}
                >
                  {stat.icon}
                  <h6 className="ms-2 mb-0 fw-semibold text-dark">{stat.title}</h6>
                </div>
                <p
                  className="display-6 fw-bold mb-0"
                  style={{
                    color: stat.icon.props.color,
                    fontSize: "1.8rem",
                  }}
                >
                  {stat.value}
                </p>
              </Card>
            </Col>))}
        </Row>
      )} */}

      {statusModalOpen && (
        <Card>
          <CardHeader>
            {/* <div className="fw-bold mb-2">Filter by Status</div> */}

            <Row className="row-cols-1 row-cols-md-4 g-2 fw-semibold align-items-center">

              <Col className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  checked={selectedStatuses.length === allStatuses.length}
                  onChange={(e) => {
                    if (e.target.checked) setSelectedStatuses(allStatuses);
                    else setSelectedStatuses([]);
                  }}
                />
                <span>Select All</span>
              </Col>

              {/* <Col className="d-flex align-items-center gap-2">
                              <Input
                                type="checkbox"
                                onChange={() => setSelectedStatuses([])}
                              />
                              <span>Unselect All</span>
                            </Col> */}

              <Col className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  checked={inProgressStatuses.every(s => selectedStatuses.includes(s))}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedStatuses(Array.from(new Set([...selectedStatuses, ...inProgressStatuses])));
                    } else {
                      setSelectedStatuses(selectedStatuses.filter(s => !inProgressStatuses.includes(s)));
                    }
                  }}
                />
                <span>Select All In-Progress</span>
              </Col>
              <Col className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  checked={ToDoStatuses.every(s => selectedStatuses.includes(s))}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedStatuses(Array.from(new Set([...selectedStatuses, ...ToDoStatuses])));
                    } else {
                      setSelectedStatuses(selectedStatuses.filter(s => !ToDoStatuses.includes(s)));
                    }
                  }}
                />
                <span>Select All ToDo</span>
              </Col>

              <Col className="d-flex align-items-center gap-2">
                <Input
                  type="checkbox"
                  checked={completedStatuses.every(s => selectedStatuses.includes(s))}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedStatuses(Array.from(new Set([...selectedStatuses, ...completedStatuses])));
                    } else {
                      setSelectedStatuses(selectedStatuses.filter(s => !completedStatuses.includes(s)));
                    }
                  }}
                />
                <span>Select All Completed</span>
                <Button style={{ marginLeft: "250px" }} close onClick={() => setStatusModalOpen(false)} />
              </Col>


            </Row>
          </CardHeader>


          <CardBody style={{ padding: "20px" }}>

            {/* --------- Master Controls --------- */}


            {/* --------- Status List --------- */}
            <Row className="row-cols-6">
              {allStatuses.map((status) => (
                <Col key={status} className="mb-2">
                  <div className="d-flex align-items-center">
                    <Input
                      id={`status-${status}`}
                      type="checkbox"
                      checked={selectedStatuses.includes(status)}
                      onChange={() => {
                        selectedStatuses.includes(status)
                          ? setSelectedStatuses(selectedStatuses.filter(s => s !== status))
                          : setSelectedStatuses([...selectedStatuses, status]);
                      }}
                    />
                    <Label check htmlFor={`status-${status}`} className="ms-2" style={{ cursor: "pointer" }}>
                      {status}
                    </Label>
                  </div>
                </Col>
              ))}
            </Row>

            {/* <div className="text-end mt-3">
                <Button color="secondary" className="me-2" onClick={() => {
                  setSelectedStatuses([]);
                  setStatusModalOpen(false);
                }}> Clear </Button>

                <Button color="primary" onClick={() => setStatusModalOpen(false)}>
                  Apply
                </Button>
              </div> */}

          </CardBody>
        </Card>
      )}

      {/* ==== Show Table if a project or all projects is selected ==== */}
      {projectFilter && (
        <Card className="shadow-sm border-0 rounded-3">
          <CardBody>
            {loadingTasks ? (
              <div className="text-center">
                <Spinner />
                <p>Loading tasks...</p>
              </div>
            ) : filteredTasks.length === 0 ? (
              <div className="text-center text-muted p-4">No tasks for this project.</div>
            ) : (
              <div className="task-table-wrapper">
                <Table size="sm" responsive>
                  <thead>
                    <tr className="text-white" style={{ textAlign: "start" }}>
                      {columns
                        .filter(col => visibleColumns.includes(col.key))
                        .map((col, index) => (
                          <th
                            key={col.key}
                            draggable
                            onDragStart={() => handleDragStart(index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(index)}
                            style={{ cursor: "grab", width: col.width }}
                          >
                            {col.key === "completion" ? (
                              <td
                                color={useWeekdays ? "light" : "light"}
                                onClick={(e) => {
                                  e.stopPropagation(); // 🔥 prevent sort on button click
                                  setUseWeekdays(prev => {
                                    const v = !prev;
                                    localStorage.setItem("useWeekdays", String(v));
                                    return v;
                                  });
                                }}
                                title={
                                  useWeekdays
                                    ? "Switch to Calendar Days (Mon–Sun)"
                                    : "Switch to Working Days (Mon–Fri)"
                                }
                              >
                                Due {useWeekdays ? "(WD)" : "(CD)"}
                              </td>
                            ) : (
                              col.label
                            )}
                          </th>
                        ))}
                    </tr>
                  </thead>


                  <tbody>
                    {filteredTasks
                      .filter(task => {
                        if (!showCompletedReleased && (task.status === "Completed" || task.status === "Released")) return false;
                        if (!showNotInScope && task.status === "NotInScope") return false; return true;
                      })
                      .map(task => {
                        const resolvedPriority = priorityValues.includes(task.priority ?? "") ? task.priority! : "Medium";
                        return (
                          <React.Fragment key={task.id}>
                            {/* ===== Task Row ===== */}
                            <tr className="table-light" style={{ backgroundColor: '#d8d8dbff' }}>
                              {columns.map(col => {
                                if (editingTaskId === task.id && col.key === "comment") return null; // hide comment during edit
                                switch (col.key) {
                                  case "number":
                                    return (
                                      <td key="number">
                                        <div className="d-flex align-items-center gap-1">

                                          {/* ⏰ Add Time – only assigned user */}
                                          {/* {currentUser?.name === task.assignedToName && (
                                            <AddAlarmIcon
                                              style={{ cursor: "pointer", color: "#000000ff" }}
                                              titleAccess="Add spent hours"
                                              onClick={() => {
                                                setSelectedTaskForTime(task);
                                                setSelectedSubTaskForTime(null); // task-only
                                                toggleAddModal();
                                              }}
                                            />
                                          )} */}


                                          {task.subTasks && task.subTasks.length > 0 && (
                                            <Button color="link" size="sm" onClick={() => toggleTask(task.id)}>
                                              {expandedTasks[task.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                            </Button>

                                          )}
                                        </div>
                                      </td>
                                    );
                                  case "description": return <td>{task.description}</td>;



                                  case "maxHours": {
                                    if (!visibleColumns.includes("maxHours")) return null;

                                    const max = getMaxTaskTotal(task);
                                    return <td>{toDisplayValue(max)}{unitLabel}</td>;
                                  }

                                  case "spendhours": {
                                    if (!visibleColumns.includes("spendhours")) return null;
                                    const spent = getTaskTotal(task);
                                    return <td>{toDisplayValue(spent)}{unitLabel}</td>
                                  }


                                  case "Remaining": {
                                    if (!visibleColumns.includes("Remaining")) return null;

                                    const spent = getTaskTotal(task);
                                    const max = getMaxTaskTotal(task);
                                    const remaining = max - spent;

                                    return (
                                      <td style={{ color: remaining < 0 ? "red" : "inherit" }}>
                                        {toDisplayValue(remaining)}{unitLabel}
                                      </td>
                                    );
                                  }





                                  case "priority": return <td><Badge className={priorityColorMap[resolvedPriority]}>{resolvedPriority}</Badge></td>;
                                  case "assigned": return <td>{task.assignedToName}</td>;
                                  case "createdByName":
                                    return visibleColumns.includes("createdByName") ? (
                                      <td>{task.createdByName ?? "—"}</td>
                                    ) : null;
                                  case "status":
                                    return editingTaskId === task.id ? (
                                      <td><Input type="select" name="status" value={taskEditData.status || ""}
                                        onChange={(e) =>
                                          handleStatusChangeWithReason(
                                            e,
                                            task,
                                            "task"
                                          )
                                        }
                                      >
                                        {projectStatusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                      </Input></td>
                                    ) : (
                                      <td><Badge className={statusColorMap[task.status] || ""}>{formatStatusLabel(task.status)}</Badge></td>
                                    );
                                  // case "completion":
                                  //   return <td>{formatDate(task.completionDate)}</td>;

                                  case "dueDate":
                                    return (<td > {formatDate(task.dueDate)}
                                      <span
                                        className="text-black ms-1"
                                        title={task.isDueDateLocked ? "Due date is locked by admin" : ""}
                                      >
                                        {task.isDueDateLocked && <HttpsIcon fontSize="small" />}
                                      </span>

                                    </td>);
                                  case "completion": {
                                    if (!task.dueDate) return <td>—</td>;

                                    const due = new Date(task.dueDate);
                                    const today = new Date();
                                    const completed = task.completionDate
                                      ? new Date(task.completionDate)
                                      : null;

                                    const status = task.status?.toLowerCase();

                                    // normalize time
                                    due.setHours(0, 0, 0, 0);
                                    today.setHours(0, 0, 0, 0);
                                    completed?.setHours(0, 0, 0, 0);

                                    const isCompleted =
                                      status === "released" && completed !== null;

                                    const calculateDiff = (start: Date, end: Date) =>
                                      useWeekdays
                                        ? countWeekdaysSigned(start, end)
                                        : Math.round(
                                          (end.getTime() - start.getTime()) /
                                          (1000 * 60 * 60 * 24)
                                        );

                                    let diff = 0;
                                    let tooltipText = "";
                                    let displayText = "";

                                    // ✅ COMPLETED TASK
                                    if (isCompleted) {
                                      diff = calculateDiff(due, completed!);

                                      if (diff === 0) {
                                        tooltipText = "Completed On Time";
                                      } else if (diff < 0) {
                                        tooltipText = `Completed Early by ${Math.abs(diff)} days`;
                                      } else {
                                        tooltipText = `Completed Late by ${diff} days`;
                                      }

                                      displayText = "Completed";
                                    }
                                    // ✅ ACTIVE TASK
                                    else {
                                      // ✅ IMPORTANT: today first, due second
                                      diff = calculateDiff(today, due);

                                      if (diff === 0) {
                                        displayText = "0 day";
                                        tooltipText = "Due today";
                                      } else if (diff < 0) {
                                        displayText = `${diff} day${Math.abs(diff) === 1 ? "" : "s"}`;
                                        tooltipText = `Overdue by ${Math.abs(diff)} days`;
                                      } else {
                                        displayText = `${diff} day${diff === 1 ? "" : "s"}`;
                                        tooltipText = `${diff} days remaining`;
                                      }
                                    }

                                    const color = getDueColor(diff, isCompleted);

                                    return (
                                      <td title={tooltipText} style={{ color, fontWeight: 600 }}>
                                        {displayText}
                                      </td>
                                    );
                                  }

                                  case "hours": {
                                    const spent = getTaskTotal(task);
                                    const max = getMaxTaskTotal(task);
                                    const remaining = max - spent;

                                    const hoursPercent =
                                      max > 0
                                        ? Math.min(100, Math.round((spent / max) * 100))
                                        : 0;

                                    const isMatch = hoursPercent === task.percentCompleted;

                                    return (
                                      <td key={col.key} style={{ minWidth: "120px" }}>
                                        <Tooltip
                                          arrow
                                          title={
                                            <>
                                              <div>Max: {toDisplayValue(max)}{unitLabel}</div>
                                              <div>Spent: {toDisplayValue(spent)}{unitLabel}</div>
                                              <div>Rem: {toDisplayValue(remaining)}{unitLabel}</div>
                                            </>
                                          }
                                        >
                                          <div className="d-flex flex-column gap-1">
                                            <Progress
                                              value={hoursPercent}
                                              max={100}
                                              color={isMatch ? "primary" : "danger"}
                                              style={{ cursor: "pointer" }}
                                            >
                                              <strong>{hoursPercent}%</strong>
                                            </Progress>
                                          </div>
                                        </Tooltip>
                                      </td>
                                    );
                                  }


                                  case "percentCompleted": {
                                    if (!visibleColumns.includes("percentCompleted")) return null;

                                    return editingTaskId === task.id ? (
                                      <td>
                                        <Input
                                          type="number"
                                          name="percentCompleted"
                                          value={taskEditData.percentCompleted || ""}
                                          onChange={onTaskChange}
                                        />
                                      </td>
                                    ) : (
                                      <td style={{ minWidth: "90px" }}>
                                        <Tooltip
                                          arrow
                                          title={
                                            <>
                                              <div>{task.percentCompleted || 0}% completed</div>
                                            </>
                                          }
                                        >
                                          <Progress
                                            value={task.percentCompleted || 0}
                                          >

                                          </Progress>
                                        </Tooltip>
                                      </td>
                                    );
                                  }



                                  case "remarks":
                                    return editingTaskId === task.id ? (
                                      <td><Input type="textarea" name="remarks" value={taskEditData.remarks || ""} onChange={onTaskChange} /></td>
                                    ) : <td>{task.remarks || "—"}</td>;
                                  case "issues":
                                    return editingTaskId === task.id ? (
                                      <td><Input type="textarea" name="issues" value={taskEditData.issues || ""} onChange={onTaskChange} /></td>
                                    ) : <td>{task.issues || "—"}</td>;
                                  case "comment": {
                                    const key = `t-${task.id}`;
                                    const total = totalCommentCount[key] ?? 0;
                                    const unread = unreadCounts[key] ?? 0;

                                    return (
                                      <td>
                                        <Button
                                          className="position-relative"
                                          color="link"
                                          size="sm"
                                          onClick={() => {
                                            openComments("task", task.id);

                                            setUnreadCounts(prev => {
                                              const updated = { ...prev, [key]: 0 };
                                              localStorage.setItem("unreadCounts", JSON.stringify(updated));
                                              return updated;
                                            });
                                          }} >

                                          {total === 0 && <ChatBubbleOutlineIcon fontSize="small" style={{ color: "blue" }} />}
                                          {total > 0 && unread === 0 && <ChatIcon fontSize="small" style={{ color: "#0891ff" }} />}

                                          {unread > 0 && (
                                            <>
                                              <MarkChatUnreadIcon fontSize="small" style={{ color: "blue" }} />
                                              <Badge
                                                className="position-absolute top-0 start-100 translate-middle"
                                                style={{ background: "#d32f2f", fontSize: "11px", padding: "3px 6px", borderRadius: "14px" }}
                                              >
                                                {unread}
                                              </Badge>
                                            </>
                                          )}
                                        </Button>
                                      </td>
                                    );
                                  }






                                  case "log":
                                    return (
                                      <td>

                                        <Button
                                          color="link"
                                          size="sm"
                                          onClick={() => {
                                            setSelectedLogEntity({ type: "task", id: task.id, title: task.description });
                                            loadOverallLogs("task", task.id);
                                          }}
                                        >
                                          {formatDate(task.completionDate)}{" "}
                                        </Button>
                                      </td>
                                    );


                                  case "actions":
                                    return (
                                      <td>
                                        {editingTaskId === task.id ? (
                                          <div className="d-flex gap-2">
                                            <Button size="sm" color="success" onClick={saveTask}><SaveIcon /></Button>
                                            <Button size="sm" color="secondary" onClick={cancelTaskEdit}><CancelIcon /></Button>
                                          </div>
                                        ) : (
                                          currentUser?.name === task.assignedToName && (


                                            <Button
                                              size="sm"
                                              onClick={() => startTaskEdit(task)}
                                              className="border-0 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                              style={{
                                                width: "32px",
                                                height: "32px",
                                                backgroundColor: "#e7f3ff",
                                                transition: "all 0.2s ease-in-out",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = "#d0e7ff";
                                                e.currentTarget.style.transform = "scale(1.05)";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = "#e7f3ff";
                                                e.currentTarget.style.transform = "scale(1)";
                                              }}
                                            >
                                              <EditIcon fontSize="small" className="text-primary" />
                                            </Button>
                                          )

                                        )}
                                      </td>
                                    );
                                  default: return <td key={col.key}></td>;
                                }
                              })}
                            </tr>

                            {/* ===== Subtasks ===== */}
                            {expandedTasks[task.id] &&
                              (task.subTasks || [])
                                .filter(subtask => {
                                  if (!showCompletedReleased && (subtask.status === "Completed" || subtask.status === "Released")) return false;
                                  if (!showNotInScope && subtask.status === "NotInScope") return false; return true;
                                })
                                .map((subtask: SubTaskList) => (
                                  <React.Fragment key={subtask.id}>

                                    {/* ================= SUBTASK ROW ================= */}
                                    <tr style={{ backgroundColor: "#fffbe6" }}>


                                      {columns.map(col => {

                                        if (editingSubtaskId === subtask.id && col.key === "comment") return null;

                                        switch (col.key) {
                                          case "number":
                                            return (

                                              <td key="number" className="text-center" >
                                                <div className="d-flex " style={{ marginLeft: "40px" }}>

                                                  {(subtask.childSubTasks?.length ?? 0) > 0 && (
                                                    <Button size="sm" color="link" onClick={() => toggleSubtask(subtask.id)}>
                                                      {expandedSubtasks[subtask.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                    </Button>
                                                  )}


                                                  {/* {currentUser?.name === subtask.assignedToName && (
                                                    <AddAlarmIcon
                                                      style={{ cursor: "pointer", color: "#000000ff" }}
                                                      onClick={() => {
                                                        setSelectedTaskForTime(task);
                                                        setSelectedSubTaskForTime(subtask);
                                                        toggleAddModal();
                                                      }}
                                                    />
                                                  )} */}
                                                </div>
                                              </td>
                                            );


                                          case "description": return <td>{subtask.description}</td>;


                                          case "maxHours": {
                                            if (!visibleColumns.includes("maxHours")) return null;

                                            const max = getMaxSubtaskTotal(subtask);
                                            return <td>{toDisplayValue(max)}{unitLabel}</td>;
                                          }


                                          case "spendhours": {
                                            if (!visibleColumns.includes("spendhours")) return null;

                                            const spent = getSubtaskTotal(subtask);
                                            return <td>{toDisplayValue(spent)}{unitLabel}</td>
                                          }



                                          case "Remaining": {
                                            if (!visibleColumns.includes("Remaining")) return null;

                                            const spent = getSubtaskTotal(subtask);
                                            const max = getMaxSubtaskTotal(subtask);
                                            const remaining = max - spent;

                                            return (
                                              <td style={{ color: remaining < 0 ? "red" : "inherit" }}>
                                                {toDisplayValue(remaining)}{unitLabel}
                                              </td>
                                            );
                                          }




                                          case "priority": return <td><Badge className={priorityColorMap[subtask.priority ?? "Medium"]}>{subtask.priority}</Badge></td>;
                                          case "assigned": return <td>{subtask.assignedToName}</td>;
                                          case "createdByName":
                                            return visibleColumns.includes("createdByName") ? (
                                              <td>{subtask.createdByName ?? "—"}</td>
                                            ) : null;
                                          case "status":
                                            return editingSubtaskId === subtask.id ? (
                                              <td><Input type="select" name="status" value={subtaskEditData.status || ""}

                                                onChange={(e) =>
                                                  handleStatusChangeWithReason(
                                                    e,
                                                    subtask,
                                                    "subtask"
                                                  )
                                                }
                                              >
                                                {projectStatusOptions.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
                                              </Input></td>
                                            ) : <td><Badge className={statusColorMap[subtask.status] || ""}>{formatStatusLabel(subtask.status)}</Badge></td>;
                                          //  case "completion": 
                                          //     return <td>{formatDate(subtask.completionDate)}</td>;

                                          case "dueDate":
                                            return (
                                              <td>
                                                {formatDate(subtask.dueDate)}
                                                <span
                                                  className="text-black ms-1"
                                                  title={subtask.isDueDateLocked ? "Due date is locked by admin" : ""}
                                                >
                                                  {subtask.isDueDateLocked && <HttpsIcon fontSize="small" />}
                                                </span>
                                              </td>
                                            );


                                          case "completion": {
                                            if (!subtask.dueDate) return <td>—</td>;

                                            const due = new Date(subtask.dueDate);
                                            const today = new Date();
                                            const completed = subtask.completionDate
                                              ? new Date(subtask.completionDate)
                                              : null;

                                            const status = subtask.status?.toLowerCase();

                                            // normalize time
                                            due.setHours(0, 0, 0, 0);
                                            today.setHours(0, 0, 0, 0);
                                            completed?.setHours(0, 0, 0, 0);

                                            const isCompleted =
                                              status === "released" && completed !== null;

                                            const calculateDiff = (start: Date, end: Date) =>
                                              useWeekdays
                                                ? countWeekdaysSigned(start, end)
                                                : Math.round(
                                                  (end.getTime() - start.getTime()) /
                                                  (1000 * 60 * 60 * 24)
                                                );

                                            let diff = 0;
                                            let tooltipText = "";
                                            let displayText = "";

                                            // ✅ COMPLETED SUBTASK
                                            if (isCompleted) {
                                              diff = calculateDiff(due, completed!);

                                              if (diff === 0) {
                                                tooltipText = "Completed On Time";
                                              } else if (diff < 0) {
                                                tooltipText = `Completed Early by ${Math.abs(diff)} days`;
                                              } else {
                                                tooltipText = `Completed Late by ${diff} days`;
                                              }

                                              displayText = "Completed";
                                            }
                                            // ✅ ACTIVE SUBTASK
                                            else {
                                              // ✅ IMPORTANT: today first, due second
                                              diff = calculateDiff(today, due);

                                              if (diff === 0) {
                                                displayText = "0 day";
                                                tooltipText = "Due today";
                                              } else if (diff < 0) {
                                                displayText = `${diff} day${Math.abs(diff) === 1 ? "" : "s"}`;
                                                tooltipText = `Overdue by ${Math.abs(diff)} days`;
                                              } else {
                                                displayText = `${diff} day${diff === 1 ? "" : "s"}`;
                                                tooltipText = `${diff} days remaining`;
                                              }
                                            }

                                            const color = getDueColor(diff, isCompleted);

                                            return (
                                              <td title={tooltipText} style={{ color, fontWeight: 600 }}>
                                                {displayText}
                                              </td>
                                            );
                                          }

                                          case "hours": {
                                            if (!visibleColumns.includes("hours")) return null;

                                            const spent = getSubtaskTotal(subtask);
                                            const max = getMaxSubtaskTotal(subtask);
                                            const remaining = max - spent;

                                            const hoursPercent =
                                              max > 0
                                                ? Math.min(100, Math.round((spent / max) * 100))
                                                : 0;

                                            const isMatch = hoursPercent === subtask.percentCompleted;

                                            return (
                                              <td key={col.key} style={{ minWidth: "120px" }}>
                                                <Tooltip
                                                  title={
                                                    <>
                                                      <div>Max: {toDisplayValue(max)}{unitLabel}</div>
                                                      <div>Spent: {toDisplayValue(spent)}{unitLabel}</div>
                                                      <div>Rem: {toDisplayValue(remaining)}{unitLabel}</div>
                                                    </>
                                                  }
                                                  arrow
                                                >
                                                  <div className="d-flex flex-column gap-1">
                                                    <Progress
                                                      value={hoursPercent}
                                                      max={100}
                                                      color={isMatch ? "primary" : "danger"}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                      <strong>{hoursPercent}%</strong>
                                                    </Progress>
                                                  </div>
                                                </Tooltip>
                                              </td>
                                            );
                                          }
                                          case "percentCompleted": {
                                            if (!visibleColumns.includes("percentCompleted")) return null;

                                            return editingSubtaskId === subtask.id ? (
                                              <td>
                                                <Input
                                                  type="number"
                                                  name="percentCompleted"
                                                  value={subtaskEditData.percentCompleted || ""}
                                                  onChange={onSubtaskChange}

                                                  min="0"
                                                  max="100"
                                                />
                                              </td>
                                            ) : (
                                              <td style={{ minWidth: "90px" }}>
                                                <Tooltip
                                                  title={
                                                    <>
                                                      <div>{subtask.percentCompleted || 0}% completed</div>
                                                    </>
                                                  }
                                                  arrow
                                                >
                                                  <Progress
                                                    value={subtask.percentCompleted || 0}
                                                  >

                                                  </Progress>
                                                </Tooltip>
                                              </td>
                                            );
                                          }


                                          case "remarks":
                                            return editingSubtaskId === subtask.id ? (
                                              <td><Input type="textarea" name="remarks" value={subtaskEditData.remarks || ""} onChange={onSubtaskChange} /></td>
                                            ) : <td>{subtask.remarks || "—"}</td>;
                                          case "issues":
                                            return editingSubtaskId === subtask.id ? (
                                              <td><Input type="textarea" name="issues" value={subtaskEditData.issues || ""} onChange={onSubtaskChange} /></td>
                                            ) : <td>{subtask.issues || "—"}</td>;
                                          case "comment": {
                                            const key = `s-${subtask.id}`;
                                            const total = totalCommentCount[key] ?? 0;
                                            const unread = unreadCounts[key] ?? 0;

                                            return (
                                              <td>
                                                <Button
                                                  className="position-relative"
                                                  color="link"
                                                  size="sm"
                                                  onClick={() => {
                                                    openComments("subtask", subtask.id);

                                                    setUnreadCounts(prev => {
                                                      const updated = { ...prev, [key]: 0 };
                                                      localStorage.setItem("unreadCounts", JSON.stringify(updated));
                                                      return updated;
                                                    });
                                                  }}

                                                >

                                                  {total === 0 && <ChatBubbleOutlineIcon fontSize="small" style={{ color: "blue" }} />}
                                                  {total > 0 && unread === 0 && <ChatIcon fontSize="small" style={{ color: "#0891ff" }} />}

                                                  {unread > 0 && (
                                                    <>
                                                      <MarkChatUnreadIcon fontSize="small" style={{ color: "blue" }} />
                                                      <Badge
                                                        className="position-absolute top-0 start-100 translate-middle"
                                                        style={{ background: "#ec0101ff", fontSize: "11px", padding: "3px 6px", borderRadius: "14px" }}
                                                      >
                                                        {unread}
                                                      </Badge>
                                                    </>
                                                  )}
                                                </Button>
                                              </td>
                                            );
                                          }
                                          case "log":
                                            return (
                                              <td>

                                                <Button
                                                  color="link"
                                                  size="sm"
                                                  onClick={() => {
                                                    setSelectedLogEntity({ type: "subtask", id: subtask.id, title: subtask.description });
                                                    loadOverallLogs("subtask", subtask.id);
                                                  }}
                                                >
                                                  {formatDate(subtask.completionDate)}{" "}
                                                </Button>
                                              </td>
                                            );
                                          case "actions":
                                            return (
                                              <td>
                                                {editingSubtaskId === subtask.id ? (
                                                  <div className="d-flex gap-2">
                                                    <Button size="sm" color="success" onClick={saveSubtask}><SaveIcon /></Button>
                                                    <Button size="sm" color="secondary" onClick={cancelSubtaskEdit}><CancelIcon /></Button>
                                                  </div>
                                                ) : (
                                                  currentUser?.name === subtask.assignedToName && (

                                                    <Button
                                                      size="sm" onClick={() => startSubtaskEdit(subtask)}
                                                      className="border-0 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                      style={{
                                                        width: "32px",
                                                        height: "32px",
                                                        backgroundColor: "#e7f3ff",
                                                        transition: "all 0.2s ease-in-out",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#d0e7ff";
                                                        e.currentTarget.style.transform = "scale(1.05)";
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = "#e7f3ff";
                                                        e.currentTarget.style.transform = "scale(1)";
                                                      }}
                                                    >
                                                      <EditIcon fontSize="small" className="text-primary" />
                                                    </Button>
                                                  )
                                                )}
                                              </td>
                                            );
                                          default: return <td></td>;
                                        }
                                      })}
                                    </tr>

                                    {/* ================= CHILD SUBTASK ROWS ================= */}
                                    {expandedSubtasks[subtask.id] &&
                                      subtask.childSubTasks?.map((child: ChildSubTask) => (
                                        <tr key={child.id} style={{ background: "#eef6ff" }}>
                                          {columns.map(col => {

                                            switch (col.key) {

                                              case "number":
                                                return <td key="number">
                                                  <div style={{ marginLeft: "50px" }}>
                                                    {child.teamMemberNames?.includes(currentUser?.name || "") && (
                                                      <AddAlarmIcon
                                                        style={{ cursor: "pointer", color: "#000000ff" }}
                                                        onClick={() => {
                                                          setSelectedTaskForTime(task);
                                                          setSelectedSubTaskForTime(subtask);
                                                          setSelectedChildSubTaskForTime(child);
                                                          toggleAddModal();
                                                        }}
                                                      />
                                                    )}</div>
                                                </td>;

                                              case "description":
                                                return <td key={col.key} className="ps-4">↳ {child.description}</td>;

                                              case "maxHours":
                                                if (!visibleColumns.includes("maxHours")) return null;
                                                return <td key={col.key}>{toDisplayValue(child.maxHours ?? 0)}{unitLabel}</td>;

                                              case "spendhours": {
                                                if (!visibleColumns.includes("spendhours")) return null;

                                                const spent = child.spentHours ?? 0;

                                                return (
                                                  <td key={col.key}>
                                                    {toDisplayValue(spent)}{unitLabel}
                                                  </td>
                                                );
                                              }

                                              case "Remaining": {
                                                if (!visibleColumns.includes("Remaining")) return null;

                                                const spent = child.spentHours ?? 0;
                                                const max = child.maxHours ?? 0;
                                                const remaining = max - spent;

                                                return (
                                                  <td
                                                    key={col.key}
                                                    style={{ color: remaining < 0 ? "red" : "inherit" }}
                                                  >
                                                    {toDisplayValue(remaining)}{unitLabel}
                                                  </td>
                                                );
                                              }



                                              case "priority":
                                                return <td key={col.key}><Badge className={priorityColorMap[child.priority ?? "Medium"]}>{child.priority}</Badge></td>;

                                              case "assigned":
                                                return (
                                                  <td key={col.key}>
                                                    {child.teamMemberNames && child.teamMemberNames.length > 0 ? (
                                                      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
                                                        {child.teamMemberNames.map((name: string, idx: number) => (
                                                          <UserAvatar key={idx} name={name} />
                                                        ))}
                                                      </div>
                                                    ) : (
                                                      <span className="text-muted">—</span>
                                                    )}
                                                  </td>
                                                );


                                              case "createdByName":
                                                return visibleColumns.includes("createdByName") ? (
                                                  <td>{child.createdByName}</td>
                                                ) : null;
                                              case "status":
                                                return (
                                                  <td key={col.key}>
                                                    {editingChildSubtaskId === child.id ? (
                                                      <Input
                                                        type="select"
                                                        name="status"
                                                        value={childSubtaskEditData.status || ""}
                                                        onChange={onChildSubtaskChange}
                                                      >
                                                        {getStatusOptions(child.description).map(opt => (
                                                          <option key={opt.value} value={opt.value}>
                                                            {opt.label}
                                                          </option>
                                                        ))}
                                                      </Input>
                                                    ) : (
                                                      <Badge className={statusColorMap[child.status] || ""}>
                                                        {childformatStatusLabel(child.status)}
                                                      </Badge>
                                                    )}
                                                  </td>
                                                );


                                              case "dueDate":
                                                return <td key={col.key}>{formatDate(child.dueDate)}</td>;

                                              case "hours": {
                                                if (!visibleColumns.includes("hours")) return null;

                                                const max = child.maxHours ?? 0;
                                                const spent = child.spentHours ?? 0;
                                                const remaining = max - spent;
                                                const percent =
                                                  max > 0
                                                    ? Math.min(100, Math.round((spent / max) * 100))
                                                    : 0;

                                                return (
                                                  <td style={{ minWidth: "100px" }}>
                                                    <Tooltip
                                                      arrow
                                                      title={
                                                        <>
                                                          <div>Max: {toDisplayValue(max)}{unitLabel}</div>
                                                          <div>Spent: {toDisplayValue(spent)}{unitLabel}</div>
                                                          <div>Rem: {toDisplayValue(remaining)}{unitLabel}</div>
                                                        </>
                                                      }
                                                    >
                                                      <div>
                                                        <Progress
                                                          value={percent}
                                                          style={{ cursor: "pointer" }}
                                                        >
                                                          <strong>{percent}%</strong>
                                                        </Progress>
                                                      </div>
                                                    </Tooltip>
                                                  </td>
                                                );
                                              }

                                              case "percentCompleted": {
                                                if (!visibleColumns.includes("percentCompleted")) return null;

                                                return editingChildSubtaskId === child.id ? (
                                                  <td>
                                                    <Input
                                                      type="number"
                                                      name="percentCompleted"
                                                      value={childSubtaskEditData.percentCompleted || ""}
                                                      onChange={onChildSubtaskChange}

                                                    />
                                                  </td>
                                                ) : (
                                                  <td style={{ minWidth: "90px" }}>
                                                    <Tooltip
                                                      arrow
                                                      title={
                                                        <>
                                                          <div>{child.percentCompleted || 0}% completed</div>
                                                        </>
                                                      }
                                                    >
                                                      <Progress
                                                        value={child.percentCompleted || 0}
                                                      >

                                                      </Progress>
                                                    </Tooltip>
                                                  </td>
                                                );
                                              }

                                              case "completion": {
                                                if (!child.dueDate) return <td>—</td>;

                                                const due = new Date(child.dueDate);
                                                const today = new Date();
                                                const completed = child.completionDate
                                                  ? new Date(child.completionDate)
                                                  : null;

                                                const status = child.status?.toLowerCase();

                                                // normalize time
                                                due.setHours(0, 0, 0, 0);
                                                today.setHours(0, 0, 0, 0);
                                                completed?.setHours(0, 0, 0, 0);

                                                const isCompleted =
                                                  status === "released" && completed !== null;

                                                const calculateDiff = (start: Date, end: Date) =>
                                                  useWeekdays
                                                    ? countWeekdaysSigned(start, end)
                                                    : Math.round(
                                                      (end.getTime() - start.getTime()) /
                                                      (1000 * 60 * 60 * 24)
                                                    );

                                                let diff = 0;
                                                let tooltipText = "";
                                                let displayText = "";

                                                // ✅ COMPLETED CHILD TASK
                                                if (isCompleted) {
                                                  diff = calculateDiff(due, completed!);

                                                  if (diff === 0) {
                                                    tooltipText = "Completed On Time";
                                                  } else if (diff < 0) {
                                                    tooltipText = `Completed Early by ${Math.abs(diff)} days`;
                                                  } else {
                                                    tooltipText = `Completed Late by ${diff} days`;
                                                  }

                                                  displayText = "Completed";
                                                }
                                                // ✅ ACTIVE CHILD TASK
                                                else {
                                                  // ✅ IMPORTANT: today first, due second
                                                  diff = calculateDiff(today, due);

                                                  if (diff === 0) {
                                                    displayText = "0 day";
                                                    tooltipText = "Due today";
                                                  } else if (diff < 0) {
                                                    displayText = `${diff} day${Math.abs(diff) === 1 ? "" : "s"}`;
                                                    tooltipText = `Overdue by ${Math.abs(diff)} days`;
                                                  } else {
                                                    displayText = `${diff} day${diff === 1 ? "" : "s"}`;
                                                    tooltipText = `${diff} days remaining`;
                                                  }
                                                }

                                                const color = getDueColor(diff, isCompleted);

                                                return (
                                                  <td title={tooltipText} style={{ color, fontWeight: 600 }}>
                                                    {displayText}
                                                  </td>
                                                );
                                              }


                                              case "log":
                                                return <td key={col.key}>
                                                  <Button
                                                    color="link"
                                                    size="sm"
                                                    onClick={() => {
                                                      setSelectedLogEntity({ type: "child-subtasks", id: child.id, title: child.description });
                                                      loadOverallLogs("child-subtasks", child.id);
                                                    }}
                                                  >
                                                    {formatDate(child.completionDate)}{" "}
                                                  </Button>
                                                </td>;

                                              case "actions":
                                                return (
                                                  <td key={col.key}>
                                                    {editingChildSubtaskId === child.id ? (
                                                      <div className="d-flex gap-2">
                                                        <Button size="sm" color="success" onClick={saveChildSubtask}><SaveIcon /></Button>
                                                        <Button size="sm" color="secondary" onClick={cancelChildSubtaskEdit}><CancelIcon /></Button>
                                                      </div>
                                                    ) : (
                                                      <Button
                                                        size="sm" onClick={() => startChildSubtaskEdit(child)}
                                                        className="border-0 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                                        style={{
                                                          width: "32px",
                                                          height: "32px",
                                                          backgroundColor: "#e7f3ff",
                                                          transition: "all 0.2s ease-in-out",
                                                        }}
                                                        onMouseEnter={(e) => {
                                                          e.currentTarget.style.backgroundColor = "#d0e7ff";
                                                          e.currentTarget.style.transform = "scale(1.05)";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                          e.currentTarget.style.backgroundColor = "#e7f3ff";
                                                          e.currentTarget.style.transform = "scale(1)";
                                                        }}
                                                      >
                                                        <EditIcon fontSize="small" className="text-primary" />
                                                      </Button>
                                                    )}
                                                  </td>
                                                );

                                              default:
                                                return <td key={col.key}></td>;
                                            }
                                          })}
                                        </tr>
                                      ))}

                                    {/* ================= SUBTASK COMMENTS ================= */}
                                    {expandedSubtasks[subtask.id] && (
                                      <tr>
                                        <td
                                          colSpan={visibleColumns.length}
                                          style={{
                                            background: "#f5f7fb",
                                            padding: "0px",
                                            borderTop: "1px solid #d6dbe3"
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginLeft: "90px", // pushes below child rows
                                              height: "470px",
                                              overflowY: "auto",
                                              overflowX: "hidden",
                                              padding: "15px",
                                              background: "#ffffff",
                                              borderRadius: "6px",
                                            }}
                                          >
                                            <Comments
                                              isOpen={false}
                                              onClose={() => { }}
                                              entityType="subtask"
                                              entityId={subtask.id}
                                              title={subtask.description}
                                              inlineMode={true}
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    )}

                                  </React.Fragment>
                                ))}


                          </React.Fragment>
                        );
                      })}


                  </tbody>
                </Table>
              </div>
            )}

            <Modal
              isOpen={logModalOpen}
              toggle={() => setLogModalOpen(false)}
              centered
              size="xl"
            >
              <ModalHeader
                toggle={() => setLogModalOpen(false)}
                style={{
                  background: "#343a40",
                  color: "white",
                  fontWeight: 600,
                  fontSize: "18px",
                  padding: "15px 20px",
                }}
              >
                Overall Log – {selectedLogEntity?.title || `${selectedLogEntity?.type} #${selectedLogEntity?.id}`}

              </ModalHeader>

              <ModalBody
                style={{
                  background: "#f3f4f6",
                  padding: "20px",
                  borderRadius: "0 0 10px 10px",
                }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "15px",
                    boxShadow: "0px 3px 10px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                  }}
                >
                  <h6
                    style={{
                      marginBottom: "15px",
                      fontWeight: 600,
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    Change History
                  </h6>

                  <Table
                    hover
                    responsive
                    bordered
                    style={{ marginBottom: 0, borderRadius: "10px" }}
                  >
                    <thead
                      style={{
                        background: "#f0f2f5",
                        fontWeight: 600,
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      <tr>
                        <th style={{ width: "15%" }}>Field</th>
                        <th style={{ width: "20%" }}>Old</th>
                        <th style={{ width: "20%" }}>New</th>
                        <th style={{ width: "20%" }}>User</th>
                        <th style={{ width: "20%" }}>Date</th>
                      </tr>
                    </thead>

                    <tbody style={{ fontSize: "14px" }}>
                      {overallLogs.length === 0 ? (
                        <tr>
                          <td
                            colSpan={5}
                            className="text-center"
                            style={{ padding: "25px", color: "#777" }}
                          >
                            No logs found.
                          </td>
                        </tr>
                      ) : (
                        overallLogs.map((log, index) => (
                          <tr
                            key={log.id ?? index}
                            style={{
                              background: index % 2 === 0 ? "#ffffff" : "#fafafa",
                            }}
                          >
                            {/* FIELD */}
                            <td style={{ fontWeight: 600, color: "#444" }}>
                              {log.fieldName}
                            </td>

                            {/* OLD VALUE */}
                            <td>
                              <span
                                style={{
                                  padding: "4px 10px",
                                  borderRadius: "6px",
                                }}
                              >
                                {(!log.oldValue || log.oldValue === "00000000-0000-0000-0000-000000000000")
                                  ? "-"
                                  : log.oldValue}
                              </span>
                            </td>


                            {/* NEW VALUE */}
                            <td>
                              <span
                                style={{
                                  padding: "4px 10px",
                                  borderRadius: "6px",
                                }}
                              >
                                {log.newValue ?? "-"}
                              </span>
                            </td>
                            {/* <td>
                              <span
                                style={{
                                  padding: "4px 10px",
                                  borderRadius: "6px",
                                }}
                              >
                                <strong>{log.actions ?? "-"}</strong>
                              </span>
                            </td> */}

                            {/* USER */}
                            <td style={{ fontWeight: 500 }}>{log.userName}</td>

                            {/* DATE */}
                            <td style={{ color: "#555", fontSize: "12px" }}>
                              {new Date(log.logTime).toLocaleDateString("en-GB")}{" "}
                              {new Date(log.logTime).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                              })}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </div>
              </ModalBody>
            </Modal>




            {/* ================== SETTINGS MODAL ================== */}
            <Modal isOpen={settingsOpen} toggle={() => setSettingsOpen(false)} centered  >
              <ModalHeader toggle={() => setSettingsOpen(false)}>Settings</ModalHeader>

              <ModalBody>

                {/* Toggle Assigned By Column */}
                <FormGroup check className="d-flex align-items-center mb-2">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={visibleColumns.includes("createdByName")}
                      onChange={() => {
                        setVisibleColumns(prev =>
                          prev.includes("createdByName")
                            ? prev.filter(c => c !== "createdByName")
                            : [...prev, "createdByName"]
                        );
                      }}
                    />
                    <span className="ms-2">Show Assigned By Column</span>
                  </Label>
                </FormGroup>

                {/* Toggle Percent Column */}
                <FormGroup check className="d-flex align-items-center mb-2">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={visibleColumns.includes("hours")}
                      onChange={() => {
                        setVisibleColumns(prev =>
                          prev.includes("hours")
                            ? prev.filter(c => c !== "hours")
                            : [...prev, "hours"]
                        );
                      }}
                    />
                    <span className="ms-2">Show Hours Column</span>
                  </Label>
                </FormGroup>
                <FormGroup check className="d-flex align-items-center mb-2">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={visibleColumns.includes("percentCompleted")}
                      onChange={() => {
                        setVisibleColumns(prev =>
                          prev.includes("percentCompleted")
                            ? prev.filter(c => c !== "percentCompleted")
                            : [...prev, "percentCompleted"]
                        );
                      }}
                    />
                    <span className="ms-2">Show Progress Column</span>
                  </Label>
                </FormGroup>
                <div className="d-flex mb-2">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={
                        visibleColumns.includes("spendhours") &&
                        visibleColumns.includes("maxHours") &&
                        visibleColumns.includes("Remaining")
                      }
                      onChange={() => {
                        setVisibleColumns(prev => {
                          const hasAll =
                            prev.includes("spendhours") &&
                            prev.includes("maxHours") &&
                            prev.includes("Remaining");

                          const updated = hasAll
                            ? prev.filter(
                              c => !["spendhours", "maxHours", "Remaining"].includes(c)
                            )
                            : [
                              ...prev,
                              ...["spendhours", "maxHours", "Remaining"].filter(
                                c => !prev.includes(c)
                              ),
                            ];

                          localStorage.setItem("visibleColumns", JSON.stringify(updated));
                          return updated;
                        });
                      }}
                    />
                    <span className="ms-2">Show Spent / Max </span>
                  </Label>
                </div>
                <FormGroup check className="d-flex mb-2 align-items-center">
                  <Label >
                    <Input
                      type="checkbox"
                      checked={showCompletedReleased}
                      onChange={() => {
                        setShowCompletedReleased(prev => {
                          const newValue = !prev;
                          localStorage.setItem("showCompletedReleased", String(newValue)); // 🔥 Save permanently
                          return newValue;
                        });
                      }}
                    />
                    <span className="ms-2">Show Released</span>
                  </Label>
                </FormGroup>
                <FormGroup check className="d-flex mb-2 align-items-center">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={showNotInScope}
                      onChange={() => {
                        setshowNotInScope(prev => {
                          const newValue = !prev;
                          localStorage.setItem("showNotInScope", String(newValue)); // 🔥 Save permanently
                          return newValue;
                        });
                      }}
                    />
                    <span className="ms-2">Show Not In Scope</span>
                  </Label>
                </FormGroup>
                <FormGroup check className="d-flex mb-2 align-items-center">
                  <Label>
                    <Input
                      type="checkbox"
                      checked={showOnDays}
                      onChange={() => {
                        setShowOnDays(prev => {
                          const v = !prev;
                          localStorage.setItem("showOnDays", String(v));
                          return v;
                        });
                      }}
                    />
                    <span className="ms-2">Show in Hours</span>
                  </Label>
                </FormGroup>

                <hr />
                <h6>Due Color Settings</h6>

                {Object.keys(dueColorSettings).map(key => (<>
                  <div key={key} className="d-flex align-items-center mb-2">
                    <Label style={{ width: "160px" }}>{key}</Label>
                    <Input
                      type="color"
                      value={dueColorSettings[key]}
                      onChange={(e) => {
                        const updated = {
                          ...dueColorSettings,
                          [key]: e.target.value,
                        };
                        setDueColorSettings(updated);
                        localStorage.setItem("dueColorSettings", JSON.stringify(updated));
                      }}
                      style={{ width: "60px", height: "35px", padding: 2 }}
                    />


                  </div>
                </>
                ))}

                <div className="mt-3">
                  <Button
                    color="secondary"
                    size="sm"
                    onClick={() => {
                      setDueColorSettings(DEFAULT_DUE_COLORS);
                      localStorage.setItem(
                        "dueColorSettings",
                        JSON.stringify(DEFAULT_DUE_COLORS)
                      );
                    }}
                  >
                    Reset to Default
                  </Button>
                </div>

              </ModalBody>

              <ModalFooter>
                <Button
                  color="primary"
                  onClick={() => {
                    localStorage.setItem("visibleColumns", JSON.stringify(visibleColumns));
                    localStorage.setItem("showCompletedReleased", String(showCompletedReleased));
                    localStorage.setItem("useWeekdays", String(useWeekdays));  // FIXED
                    setSettingsOpen(false);
                  }}
                >
                  Apply
                </Button>
              </ModalFooter>
            </Modal>


            <Modal isOpen={addModalOpen} toggle={toggleAddModal} size="xl" centered>
              <ModalHeader toggle={toggleAddModal}>
                Log Work
              </ModalHeader>

              <ModalBody>
                <Form>

                  {/* ===== BASIC INFO ===== */}
                  <Row>
                    <Col md={3}>
                      <FormGroup>
                        {/* <Label className="fw-bold">Project</Label> */}
                        <div className="form-control bg-light">
                          {newRowData.projectName || "—"}
                        </div>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      <FormGroup>
                        {/* <Label className="fw-bold">Task</Label> */}
                        <div className="form-control bg-light">
                          {newRowData.taskDescription || "—"}
                        </div>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      <FormGroup>
                        {/* <Label className="fw-bold">Subtask</Label> */}
                        <div className="form-control bg-light">
                          {newRowData.subTaskDescription || "—"}
                        </div>
                      </FormGroup>
                    </Col>

                    <Col md={3}>
                      <FormGroup>
                        {/* <Label className="fw-bold">Child Task</Label> */}
                        <div className="form-control bg-light">
                          {newRowData.childSubTaskDescription || "—"}
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>


                  {/* ===== WORK DETAILS ===== */}
                  <Row>
                    <Col md={2}>
                      <FormGroup>
                        <Label className="fw-bold">{hoursLabel}</Label>
                        <Input
                          type="select"
                          value={newRowData.hours || ""}
                          invalid={formErrors.hours}
                          onChange={(e) =>
                            setNewRowData({ ...newRowData, hours: Number(e.target.value) })
                          }

                        >
                          <option value="">Hrs</option>
                          {hourOptions.map(h => (
                            <option key={h} value={h}>{h}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>




                    <Col md={2}>
                      <FormGroup>
                        <Label className="fw-bold">{typeLabel}</Label>
                        <Input
                          type="select"
                          value={newRowData.product || ""}
                          invalid={formErrors.product}
                          required
                          onChange={(e) =>
                            setNewRowData({ ...newRowData, product: e.target.value })
                          }

                        >
                          <option value="">Select</option>
                          {getTaskTypeOptions(newRowData.childSubTaskDescription).map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>



                    {category === "DRAFTING" && (
                      <>
                        <Col md={2}>
                          <FormGroup>
                            <Label className="fw-bold">Part Prefix</Label>
                            <Input
                              type="select"
                              value={newRowData.draftingType || ""}
                              invalid={formErrors.draftingType}
                              onChange={(e) =>
                                setNewRowData({ ...newRowData, draftingType: e.target.value })
                              }

                            >
                              <option value="">Select</option>
                              {drawingTypeOptions.map((d) => (
                                <option key={d.code} value={d.code} title={d.full}>
                                  {d.label}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>

                        <Col md={2}>
                          <FormGroup>
                            <Label title="No of pages completed" className="fw-bold">Pages done today</Label>
                            {/* <Tooltip
             placement="top"
             open={tooltipOpen}
             target="pagesTooltip"
             toggle={toggletip}
           >
                    <p>No of pages completed today</p> 
                   </Tooltip> */}
                            <Input
                              title="No of pages completed today."
                              type="text"
                              value={newRowData.quantity ?? ""}
                              invalid={formErrors.quantity}
                              onChange={(e) =>
                                setNewRowData({
                                  ...newRowData,
                                  quantity: Number(e.target.value),
                                })
                              }
                            />

                          </FormGroup>

                        </Col>

                        {/* <Tooltip ></Tooltip> */}

                        <Col md={2}>
                          <FormGroup>
                            <Label className="fw-bold">Total no of pages</Label>

                            <Input
                              title='Total no of pages in one part file'
                              type="text"
                              value={newRowData.totPages ?? ""}
                              invalid={formErrors.totPages}
                              onChange={(e) =>
                                setNewRowData({
                                  ...newRowData,
                                  totPages: Number(e.target.value),
                                })
                              }
                            />
                          </FormGroup>
                        </Col>


                      </>
                    )}

                  </Row>

                  {/* ===== REMARKS (EDITABLE) ===== */}
                  <Row>
                    <Col md={4}>
                      <FormGroup>
                        <Label className="fw-bold">Part No(s)</Label>
                        <Input
                          type='textarea'
                          rows={3}
                          value={newRowData.part || ""}
                          onChange={(e) =>
                            setNewRowData({ ...newRowData, part: e.target.value })
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col md={6}>
                      <FormGroup>
                        <Label className="fw-bold">Remarks</Label>
                        <Input
                          type="textarea"
                          rows={3}
                          value={newRowData.description || ""}
                          onChange={(e) =>
                            setNewRowData({ ...newRowData, description: e.target.value })
                          }
                          placeholder="Add remarks / work description here..."
                        />
                      </FormGroup>
                    </Col>


                  </Row>

                </Form>
              </ModalBody>


              <ModalFooter className="justify-content-between">
                <Button color="secondary" outline onClick={toggleAddModal}>
                  Cancel
                </Button>

                <Button
                  color="success"
                  disabled={isSaving}
                  onClick={handleSave}
                >
                  <CheckCircleIcon className="me-1" />
                  {isSaving ? "Saving..." : "Save"}
                </Button>

              </ModalFooter>
            </Modal>





            {/* Comments modal */}
            {commentPopup?.open && (
              <Comments
                isOpen={commentPopup.open}
                onClose={() => {
                  // Refresh unread count only for task/subtask
                  if (
                    commentPopup.type === "task" ||
                    commentPopup.type === "subtask" ||
                    commentPopup.type === "childSubTask"
                  ) {
                    loadUnreadCountFor(commentPopup.type, commentPopup.id);
                  }

                  setCommentPopup(null);
                }}

                entityType={commentPopup.type}
                entityId={commentPopup.id}
                title={commentPopup.title}
              />
            )}
          </CardBody>

        </Card>
      )}



      <Modal
        isOpen={onHoldModal}
        toggle={() => setOnHoldModal(false)}
      >
        <ModalHeader toggle={() => setOnHoldModal(false)}>
          On Hold Reason
        </ModalHeader>

        <ModalBody>

          <FormGroup>
            <Label>Reason *</Label>

            <Input
              type="textarea"
              value={onHoldReason}
              onChange={(e) =>
                setOnHoldReason(e.target.value)
              }
              placeholder="Enter reason..."
            />
          </FormGroup>

        </ModalBody>

        <ModalFooter>

          <Button
            color="secondary"
            onClick={() => setOnHoldModal(false)}
          >
            Cancel
          </Button>

          <Button
            color="primary"
            onClick={saveOnHoldReason}
          >
            Save
          </Button>

        </ModalFooter>
      </Modal>



    </Container>

  );
};

export default TaskWithSubtaskTable;
